import Vue from 'vue';
import { Editor, EditorMenuBar, EditorMenuBubble, EditorContent } from 'tiptap';
import { VTooltip, VBtn, VIcon, VToolbar, VCard, VDialog, VCardTitle, VCardText, VCardActions, VSpacer, VTextField, VRow, VCol, VImg } from 'vuetify/lib';
import { Placeholder, Heading as Heading$1, Bold as Bold$1, Italic as Italic$1, Strike as Strike$1, Underline as Underline$1, Code as Code$1, CodeBlock as CodeBlock$1, BulletList as BulletList$1, OrderedList as OrderedList$1, ListItem as ListItem$1, Blockquote as Blockquote$1, HardBreak as HardBreak$1, HorizontalRule as HorizontalRule$1, History as History$1, Link as Link$1, Image as Image$1 } from 'tiptap-extensions';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var O = 'object';
var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global_1 =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == O && globalThis) ||
  check(typeof window == O && window) ||
  check(typeof self == O && self) ||
  check(typeof commonjsGlobal == O && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

var fails = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var descriptors = !fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
var f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;

var objectPropertyIsEnumerable = {
	f: f
};

var createPropertyDescriptor = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var toString = {}.toString;

var classofRaw = function (it) {
  return toString.call(it).slice(8, -1);
};

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings



var toIndexedObject = function (it) {
  return indexedObject(requireObjectCoercible(it));
};

var isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var hasOwnProperty = {}.hasOwnProperty;

var has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var document$1 = global_1.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document$1) && isObject(document$1.createElement);

var documentCreateElement = function (it) {
  return EXISTS ? document$1.createElement(it) : {};
};

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !descriptors && !fails(function () {
  return Object.defineProperty(documentCreateElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
var f$1 = descriptors ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (ie8DomDefine) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(O, P), O[P]);
};

var objectGetOwnPropertyDescriptor = {
	f: f$1
};

var anObject = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
var f$2 = descriptors ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (ie8DomDefine) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var objectDefineProperty = {
	f: f$2
};

var hide = descriptors ? function (object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var setGlobal = function (key, value) {
  try {
    hide(global_1, key, value);
  } catch (error) {
    global_1[key] = value;
  } return value;
};

var shared = createCommonjsModule(function (module) {
var SHARED = '__core-js_shared__';
var store = global_1[SHARED] || setGlobal(SHARED, {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.2.1',
  mode:  'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});
});

var functionToString = shared('native-function-to-string', Function.toString);

var WeakMap = global_1.WeakMap;

var nativeWeakMap = typeof WeakMap === 'function' && /native code/.test(functionToString.call(WeakMap));

var id = 0;
var postfix = Math.random();

var uid = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var keys = shared('keys');

var sharedKey = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys = {};

var WeakMap$1 = global_1.WeakMap;
var set, get, has$1;

var enforce = function (it) {
  return has$1(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (nativeWeakMap) {
  var store = new WeakMap$1();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has$1 = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    hide(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return has(it, STATE) ? it[STATE] : {};
  };
  has$1 = function (it) {
    return has(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$1,
  enforce: enforce,
  getterFor: getterFor
};

var redefine = createCommonjsModule(function (module) {
var getInternalState = internalState.get;
var enforceInternalState = internalState.enforce;
var TEMPLATE = String(functionToString).split('toString');

shared('inspectSource', function (it) {
  return functionToString.call(it);
});

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) hide(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global_1) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else hide(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || functionToString.call(this);
});
});

var path = global_1;

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global_1[namespace])
    : path[namespace] && path[namespace][method] || global_1[namespace] && global_1[namespace][method];
};

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
var toInteger = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
var toLength = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(length, length).
var toAbsoluteIndex = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var indexOf = arrayIncludes.indexOf;


var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var hiddenKeys$1 = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal(O, hiddenKeys$1);
};

var objectGetOwnPropertyNames = {
	f: f$3
};

var f$4 = Object.getOwnPropertySymbols;

var objectGetOwnPropertySymbols = {
	f: f$4
};

// all object keys, includes non-enumerable and symbols
var ownKeys = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = objectGetOwnPropertyNames.f(anObject(it));
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var copyConstructorProperties = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = objectDefineProperty.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

var isForced_1 = isForced;

var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;






/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global_1;
  } else if (STATIC) {
    target = global_1[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global_1[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      hide(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
var isArray = Array.isArray || function isArray(arg) {
  return classofRaw(arg) == 'Array';
};

var createProperty = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};

var nativeSymbol = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});

var Symbol$1 = global_1.Symbol;
var store$1 = shared('wks');

var wellKnownSymbol = function (name) {
  return store$1[name] || (store$1[name] = nativeSymbol && Symbol$1[name]
    || (nativeSymbol ? Symbol$1 : uid)('Symbol.' + name));
};

var SPECIES = wellKnownSymbol('species');

var arrayMethodHasSpeciesSupport = function (METHOD_NAME) {
  return !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var SPECIES$1 = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max$1 = Math.max;

// `Array.prototype.slice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
_export({ target: 'Array', proto: true, forced: !arrayMethodHasSpeciesSupport('slice') }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES$1];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max$1(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});

var aPossiblePrototype = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    objectSetPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) objectSetPrototypeOf($this, NewTargetPrototype);
  return $this;
};

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
var objectKeys = Object.keys || function keys(O) {
  return objectKeysInternal(O, enumBugKeys);
};

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
var objectDefineProperties = descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) objectDefineProperty.f(O, key = keys[index++], Properties[key]);
  return O;
};

var html = getBuiltIn('document', 'documentElement');

var IE_PROTO = sharedKey('IE_PROTO');

var PROTOTYPE = 'prototype';
var Empty = function () { /* empty */ };

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var length = enumBugKeys.length;
  var lt = '<';
  var script = 'script';
  var gt = '>';
  var js = 'java' + script + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  iframe.src = String(js);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + script + gt + 'document.F=Object' + lt + '/' + script + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (length--) delete createDict[PROTOTYPE][enumBugKeys[length]];
  return createDict();
};

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : objectDefineProperties(result, Properties);
};

hiddenKeys[IE_PROTO] = true;

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
var whitespaces = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$1 = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod$1(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod$1(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod$1(3)
};

var getOwnPropertyNames = objectGetOwnPropertyNames.f;
var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
var defineProperty = objectDefineProperty.f;
var trim = stringTrim.trim;

var NUMBER = 'Number';
var NativeNumber = global_1[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classofRaw(objectCreate(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.github.io/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.github.io/ecma262/#sec-number-constructor
if (isForced_1(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classofRaw(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys$1 = descriptors ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys$1.length > j; j++) {
    if (has(NativeNumber, key = keys$1[j]) && !has(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor$2(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global_1, NUMBER, NumberWrapper);
}

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof = function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};

var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG$1] = 'z';

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
var objectToString = String(test) !== '[object z]' ? function toString() {
  return '[object ' + classof(this) + ']';
} : test.toString;

var ObjectPrototype = Object.prototype;

// `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
if (objectToString !== ObjectPrototype.toString) {
  redefine(ObjectPrototype, 'toString', objectToString, { unsafe: true });
}

var trim$1 = stringTrim.trim;


var nativeParseInt = global_1.parseInt;
var hex = /^[+-]?0[Xx]/;
var FORCED = nativeParseInt(whitespaces + '08') !== 8 || nativeParseInt(whitespaces + '0x16') !== 22;

// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
var _parseInt = FORCED ? function parseInt(string, radix) {
  var S = trim$1(String(string));
  return nativeParseInt(S, (radix >>> 0) || (hex.test(S) ? 16 : 10));
} : nativeParseInt;

// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
_export({ global: true, forced: parseInt != _parseInt }, {
  parseInt: _parseInt
});

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? regexpFlags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

var aFunction$1 = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};

// optional / simple context binding
var bindContext = function (fn, that, length) {
  aFunction$1(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
var toObject = function (argument) {
  return Object(requireObjectCoercible(argument));
};

var SPECIES$2 = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES$2];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var createMethod$2 = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = indexedObject(O);
    var boundFunction = bindContext(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$2(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod$2(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod$2(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod$2(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod$2(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod$2(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$2(6)
};

var sloppyArrayMethod = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !method || !fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};

var $forEach = arrayIteration.forEach;


// `Array.prototype.forEach` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
var arrayForEach = sloppyArrayMethod('forEach') ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
} : [].forEach;

for (var COLLECTION_NAME in domIterables) {
  var Collection = global_1[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== arrayForEach) try {
    hide(CollectionPrototype, 'forEach', arrayForEach);
  } catch (error) {
    CollectionPrototype.forEach = arrayForEach;
  }
}

/**
  * vue-class-component v7.1.0
  * (c) 2015-present Evan You
  * @license MIT
  */

// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
var reflectionIsSupported = typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
function copyReflectionMetadata(to, from) {
    forwardMetadata(to, from);
    Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
        forwardMetadata(to.prototype, from.prototype, key);
    });
    Object.getOwnPropertyNames(from).forEach(function (key) {
        forwardMetadata(to, from, key);
    });
}
function forwardMetadata(to, from, propertyKey) {
    var metaKeys = propertyKey
        ? Reflect.getOwnMetadataKeys(from, propertyKey)
        : Reflect.getOwnMetadataKeys(from);
    metaKeys.forEach(function (metaKey) {
        var metadata = propertyKey
            ? Reflect.getOwnMetadata(metaKey, from, propertyKey)
            : Reflect.getOwnMetadata(metaKey, from);
        if (propertyKey) {
            Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
        }
        else {
            Reflect.defineMetadata(metaKey, metadata, to);
        }
    });
}

var fakeArray = { __proto__: [] };
var hasProto = fakeArray instanceof Array;
function createDecorator(factory) {
    return function (target, key, index) {
        var Ctor = typeof target === 'function'
            ? target
            : target.constructor;
        if (!Ctor.__decorators__) {
            Ctor.__decorators__ = [];
        }
        if (typeof index !== 'number') {
            index = undefined;
        }
        Ctor.__decorators__.push(function (options) { return factory(options, key, index); });
    };
}
function mixins() {
    var Ctors = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        Ctors[_i] = arguments[_i];
    }
    return Vue.extend({ mixins: Ctors });
}
function isPrimitive(value) {
    var type = typeof value;
    return value == null || (type !== 'object' && type !== 'function');
}

function collectDataFromConstructor(vm, Component) {
    // override _init to prevent to init as Vue instance
    var originalInit = Component.prototype._init;
    Component.prototype._init = function () {
        var _this = this;
        // proxy to actual vm
        var keys = Object.getOwnPropertyNames(vm);
        // 2.2.0 compat (props are no longer exposed as self properties)
        if (vm.$options.props) {
            for (var key in vm.$options.props) {
                if (!vm.hasOwnProperty(key)) {
                    keys.push(key);
                }
            }
        }
        keys.forEach(function (key) {
            if (key.charAt(0) !== '_') {
                Object.defineProperty(_this, key, {
                    get: function () { return vm[key]; },
                    set: function (value) { vm[key] = value; },
                    configurable: true
                });
            }
        });
    };
    // should be acquired class property values
    var data = new Component();
    // restore original _init to avoid memory leak (#209)
    Component.prototype._init = originalInit;
    // create plain data object
    var plainData = {};
    Object.keys(data).forEach(function (key) {
        if (data[key] !== undefined) {
            plainData[key] = data[key];
        }
    });
    return plainData;
}

var $internalHooks = [
    'data',
    'beforeCreate',
    'created',
    'beforeMount',
    'mounted',
    'beforeDestroy',
    'destroyed',
    'beforeUpdate',
    'updated',
    'activated',
    'deactivated',
    'render',
    'errorCaptured',
    'serverPrefetch' // 2.6
];
function componentFactory(Component, options) {
    if (options === void 0) { options = {}; }
    options.name = options.name || Component._componentTag || Component.name;
    // prototype props.
    var proto = Component.prototype;
    Object.getOwnPropertyNames(proto).forEach(function (key) {
        if (key === 'constructor') {
            return;
        }
        // hooks
        if ($internalHooks.indexOf(key) > -1) {
            options[key] = proto[key];
            return;
        }
        var descriptor = Object.getOwnPropertyDescriptor(proto, key);
        if (descriptor.value !== void 0) {
            // methods
            if (typeof descriptor.value === 'function') {
                (options.methods || (options.methods = {}))[key] = descriptor.value;
            }
            else {
                // typescript decorated data
                (options.mixins || (options.mixins = [])).push({
                    data: function () {
                        var _a;
                        return _a = {}, _a[key] = descriptor.value, _a;
                    }
                });
            }
        }
        else if (descriptor.get || descriptor.set) {
            // computed properties
            (options.computed || (options.computed = {}))[key] = {
                get: descriptor.get,
                set: descriptor.set
            };
        }
    });
    (options.mixins || (options.mixins = [])).push({
        data: function () {
            return collectDataFromConstructor(this, Component);
        }
    });
    // decorate options
    var decorators = Component.__decorators__;
    if (decorators) {
        decorators.forEach(function (fn) { return fn(options); });
        delete Component.__decorators__;
    }
    // find super
    var superProto = Object.getPrototypeOf(Component.prototype);
    var Super = superProto instanceof Vue
        ? superProto.constructor
        : Vue;
    var Extended = Super.extend(options);
    forwardStaticMembers(Extended, Component, Super);
    if (reflectionIsSupported) {
        copyReflectionMetadata(Extended, Component);
    }
    return Extended;
}
var shouldIgnore = {
    prototype: true,
    arguments: true,
    callee: true,
    caller: true
};
function forwardStaticMembers(Extended, Original, Super) {
    // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
    Object.getOwnPropertyNames(Original).forEach(function (key) {
        // Skip the properties that should not be overwritten
        if (shouldIgnore[key]) {
            return;
        }
        // Some browsers does not allow reconfigure built-in properties
        var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);
        if (extendedDescriptor && !extendedDescriptor.configurable) {
            return;
        }
        var descriptor = Object.getOwnPropertyDescriptor(Original, key);
        // If the user agent does not support `__proto__` or its family (IE <= 10),
        // the sub class properties may be inherited properties from the super class in TypeScript.
        // We need to exclude such properties to prevent to overwrite
        // the component options object which stored on the extended constructor (See #192).
        // If the value is a referenced value (object or function),
        // we can check equality of them and exclude it if they have the same reference.
        // If it is a primitive value, it will be forwarded for safety.
        if (!hasProto) {
            // Only `cid` is explicitly exluded from property forwarding
            // because we cannot detect whether it is a inherited property or not
            // on the no `__proto__` environment even though the property is reserved.
            if (key === 'cid') {
                return;
            }
            var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);
            if (!isPrimitive(descriptor.value) &&
                superDescriptor &&
                superDescriptor.value === descriptor.value) {
                return;
            }
        }
        Object.defineProperty(Extended, key, descriptor);
    });
}

function Component(options) {
    if (typeof options === 'function') {
        return componentFactory(options);
    }
    return function (Component) {
        return componentFactory(Component, options);
    };
}
Component.registerHooks = function registerHooks(keys) {
    $internalHooks.push.apply($internalHooks, keys);
};

/** vue-property-decorator verson 8.2.2 MIT LICENSE copyright 2019 kaorun343 */
/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
function applyMetadata(options, target, key) {
    if (reflectMetadataIsSupported) {
        if (!Array.isArray(options) &&
            typeof options !== 'function' &&
            typeof options.type === 'undefined') {
            options.type = Reflect.getMetadata('design:type', target, key);
        }
    }
}
/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
        })(target, key);
    };
}
/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return createDecorator(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        var watch = componentOptions.watch;
        if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
            watch[path] = [watch[path]];
        }
        else if (typeof watch[path] === 'undefined') {
            watch[path] = [];
        }
        watch[path].push({ handler: handler, deep: deep, immediate: immediate });
    });
}

var toolbarConfig = {
  color: 'grey lighten-4',
  flat: true,
  dense: true
};

var TextIcon =
/** @class */
function () {
  function TextIcon(text) {
    this.text = text;
  }

  TextIcon.prototype.toString = function () {
    return this.text;
  };

  return TextIcon;
}();

var defineProperty$1 = objectDefineProperty.f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.github.io/ecma262/#sec-function-instances-name
if (descriptors && !(NAME in FunctionPrototype)) {
  defineProperty$1(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}

var VuetifyIcon =
/** @class */
function () {
  function VuetifyIcon(name) {
    this.name = name;
  }

  VuetifyIcon.prototype.toString = function () {
    return this.name;
  };

  return VuetifyIcon;
}();

var PROPS = {
  EDITOR: 'editor',
  OPTIONS: 'options',
  CONTEXT: 'context',
  DARK: 'dark'
};

var ExtensionActionRenderBtn =
/** @class */
function (_super) {
  __extends(ExtensionActionRenderBtn, _super);

  function ExtensionActionRenderBtn() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.PROPS = PROPS;
    return _this;
  }

  Object.defineProperty(ExtensionActionRenderBtn.prototype, "buttonIcon", {
    get: function get() {
      return this[PROPS.OPTIONS].icons[this.$tiptapVuetify.iconsGroup];
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ExtensionActionRenderBtn.prototype, "isTextIcon", {
    get: function get() {
      return this.buttonIcon instanceof TextIcon;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ExtensionActionRenderBtn.prototype, "isVuetifyIcon", {
    get: function get() {
      return this.buttonIcon instanceof VuetifyIcon;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ExtensionActionRenderBtn.prototype, "tooltipText", {
    get: function get() {
      var source = this.$props[PROPS.OPTIONS].tooltip;

      if (typeof source === 'function') {
        return source(this.$props[PROPS.CONTEXT], this.$props[PROPS.OPTIONS]);
      }

      return source;
    },
    enumerable: true,
    configurable: true
  });

  var _a, _b, _c, _d;

  _a = PROPS.EDITOR, _b = PROPS.OPTIONS, _c = PROPS.CONTEXT, _d = PROPS.DARK;

  __decorate([Prop({
    type: Object,
    required: true
  }), __metadata("design:type", Editor)], ExtensionActionRenderBtn.prototype, _a, void 0);

  __decorate([Prop({
    type: Object,
    required: true
  }), __metadata("design:type", Object)], ExtensionActionRenderBtn.prototype, _b, void 0);

  __decorate([Prop({
    type: Object,
    required: true
  }), __metadata("design:type", Object)], ExtensionActionRenderBtn.prototype, _c, void 0);

  __decorate([Prop({
    type: Boolean,
    default: false
  }), __metadata("design:type", Boolean)], ExtensionActionRenderBtn.prototype, _d, void 0);

  ExtensionActionRenderBtn = __decorate([Component({
    components: {
      VTooltip: VTooltip,
      VBtn: VBtn,
      VIcon: VIcon
    }
  })], ExtensionActionRenderBtn);
  return ExtensionActionRenderBtn;
}(Vue);

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

/* script */
const __vue_script__ = ExtensionActionRenderBtn;
/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({class:{
        'tiptap-vuetify-editor__action-render-btn': true,
        'v-btn--active': _vm.$props[_vm.PROPS.OPTIONS].isActive(_vm.$props[_vm.PROPS.CONTEXT])
      },attrs:{"dark":_vm.$props[_vm.PROPS.DARK],"small":"","icon":""},on:{"click":function($event){return _vm.options.onClick({ context: _vm.$props[_vm.PROPS.CONTEXT], editor: _vm.$props[_vm.PROPS.EDITOR] })}}},on),[_c(_vm.isTextIcon ? 'b' : _vm.isVuetifyIcon ? 'v-icon' : null,{tag:"component",staticClass:"tiptap-vuetify-editor__btn-icon"},[_vm._v("\n        "+_vm._s(_vm.buttonIcon)+"\n      ")])],1)]}}])},[_vm._v(" "),[_vm._v(_vm._s(_vm.tooltipText))]],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var ExtensionActionRenderBtnComponent = normalizeComponent_1(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var ExtensionActionRenderBtn$1 =
/** @class */
function () {
  function ExtensionActionRenderBtn(options) {
    var nativeExtensionName = options.nativeExtensionName;
    this.options = __assign({
      onClick: function onClick(_a) {
        var context = _a.context;
        context.commands[nativeExtensionName](options.onClickOptions);
      },
      isActive: function isActive(_a) {
        var isActive = _a.isActive;
        return !!isActive[nativeExtensionName] && isActive[nativeExtensionName](options.isActiveOptions);
      }
    }, options);
  }

  return ExtensionActionRenderBtn;
}();

var PROPS$1 = {
  EDITOR: 'editor',
  ACTIONS: 'actions',
  CONTEXT: 'context',
  DARK: 'dark'
};

var ActionsRender =
/** @class */
function (_super) {
  __extends(ActionsRender, _super);

  function ActionsRender() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.PROPS = PROPS$1;
    return _this;
  }

  ActionsRender.prototype.isBtn = function (action) {
    return action.render instanceof ExtensionActionRenderBtn$1;
  };

  var _a, _b, _c, _d;

  _a = PROPS$1.EDITOR, _b = PROPS$1.ACTIONS, _c = PROPS$1.CONTEXT, _d = PROPS$1.DARK;

  __decorate([Prop({
    type: Object,
    required: true
  }), __metadata("design:type", Editor)], ActionsRender.prototype, _a, void 0);

  __decorate([Prop({
    type: Array,
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], ActionsRender.prototype, _b, void 0);

  __decorate([Prop({
    type: Object
  }), __metadata("design:type", Object)], ActionsRender.prototype, _c, void 0);

  __decorate([Prop({
    type: Boolean,
    default: false
  }), __metadata("design:type", Boolean)], ActionsRender.prototype, _d, void 0);

  ActionsRender = __decorate([Component({
    components: {
      'action-btn': ExtensionActionRenderBtnComponent
    }
  })], ActionsRender);
  return ActionsRender;
}(Vue);

/* script */
const __vue_script__$1 = ActionsRender;
/* template */
var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.$props[_vm.PROPS.ACTIONS]),function(action,i){return [(_vm.isBtn(action))?_c('action-btn',{key:'action-button-' + i,attrs:{"options":action.render.options,"context":_vm.$props[_vm.PROPS.CONTEXT],"editor":_vm.$props[_vm.PROPS.EDITOR],"dark":_vm.$props[_vm.PROPS.DARK]}}):_vm._e()]})],2)};
var __vue_staticRenderFns__$1 = [];

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var ActionsRender$1 = normalizeComponent_1(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

var Toolbar =
/** @class */
function (_super) {
  __extends(Toolbar, _super);

  function Toolbar() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.toolbarConfig = toolbarConfig;
    return _this;
  }

  __decorate([Prop({
    type: Object,
    required: true
  }), __metadata("design:type", Editor)], Toolbar.prototype, "editor", void 0);

  __decorate([Prop({
    type: Array,
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], Toolbar.prototype, "actions", void 0);

  __decorate([Prop({
    type: [Array, Object],
    default: function _default() {
      return {};
    }
  }), __metadata("design:type", Object)], Toolbar.prototype, "toolbarAttributes", void 0);

  Toolbar = __decorate([Component({
    components: {
      ActionsRender: ActionsRender$1,
      EditorMenuBar: EditorMenuBar,
      VToolbar: VToolbar
    }
  })], Toolbar);
  return Toolbar;
}(Vue);

/* script */
const __vue_script__$2 = Toolbar;
/* template */
var __vue_render__$2 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tiptap-vuetify-editor__toolbar"},[_c('editor-menu-bar',{attrs:{"editor":_vm.editor},scopedSlots:_vm._u([{key:"default",fn:function(menuBarContext){return [_vm._t("default",[_c('v-toolbar',_vm._b({},'v-toolbar',Object.assign({}, _vm.toolbarConfig,
          _vm.toolbarAttributes),false),[_c('actions-render',{attrs:{"actions":_vm.actions,"context":menuBarContext,"editor":_vm.editor}})],1)],{"isActive":menuBarContext.isActive,"commands":menuBarContext.commands})]}}],null,true)})],1)};
var __vue_staticRenderFns__$2 = [];

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Toolbar$1 = normalizeComponent_1(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    undefined,
    undefined
  );

var PACKAGE_NAME = 'tiptap-vuetify';
var EVENTS = {
  INPUT: 'input',
  INIT: 'init'
};
var PROPS$2 = {
  VALUE: 'value',
  EXTENSIONS: 'extensions',
  TOOLBAR_ATTRIBUTES: 'toolbarAttributes',
  EDITOR_PROPERTIES: 'editorProperties',
  NATIVE_EXTENSIONS: 'nativeExtensions',
  PLACEHOLDER: 'placeholder',
  CARD_PROPS: 'cardProps',
  OUTPUT_FORMAT: 'outputFormat',
  TYPE: 'type',
  MIN_HEIGHT: 'minHeight',
  MAX_HEIGHT: 'maxHeight'
};
var EDITOR_TYPES_ENUM;

(function (EDITOR_TYPES_ENUM) {
  EDITOR_TYPES_ENUM["card"] = "card";
  EDITOR_TYPES_ENUM["inline"] = "inline";
})(EDITOR_TYPES_ENUM || (EDITOR_TYPES_ENUM = {}));

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

var regexpExec = patchedExec;

var SPECIES$3 = wellKnownSymbol('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

var fixRegexpWellKnownSymbolLogic = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };

    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$3] = function () { return re; };
    }

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
    if (sham) hide(RegExp.prototype[SYMBOL], 'sham', true);
  }
};

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classofRaw(it) == 'RegExp');
};

var SPECIES$4 = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
var speciesConstructor = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES$4]) == undefined ? defaultConstructor : aFunction$1(S);
};

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod$3 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$3(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$3(true)
};

var charAt = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
var advanceStringIndex = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classofRaw(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};

var arrayPush = [].push;
var min$2 = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { return !RegExp(MAX_UINT32, 'y'); });

// @@split logic
fixRegexpWellKnownSymbolLogic('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegexp(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return regexpExecAbstract(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = regexpExecAbstract(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = min$2(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, !SUPPORTS_Y);

var en = {
  extensions: {
    Blockquote: {
      buttons: {
        blockquote: {
          tooltip: 'Block quote'
        }
      }
    },
    Bold: {
      buttons: {
        bold: {
          tooltip: 'Bold'
        }
      }
    },
    BulletList: {
      buttons: {
        bulletList: {
          tooltip: 'Bulleted list'
        }
      }
    },
    Code: {
      buttons: {
        code: {
          tooltip: 'Code'
        }
      }
    },
    CodeBlock: {
      buttons: {
        codeBlock: {
          tooltip: 'Code block'
        }
      }
    },
    History: {
      buttons: {
        undo: {
          tooltip: 'Undo'
        },
        redo: {
          tooltip: 'Redo'
        }
      }
    },
    HorizontalRule: {
      buttons: {
        horizontalRule: {
          tooltip: 'Horizontal line'
        }
      }
    },
    Italic: {
      buttons: {
        italic: {
          tooltip: 'Italic'
        }
      }
    },
    OrderedList: {
      buttons: {
        orderedList: {
          tooltip: 'Ordered list'
        }
      }
    },
    Paragraph: {
      buttons: {
        paragraph: {
          tooltip: 'Paragraph'
        }
      }
    },
    Strike: {
      buttons: {
        strike: {
          tooltip: 'Strike'
        }
      }
    },
    Underline: {
      buttons: {
        underline: {
          tooltip: 'Underline'
        }
      }
    },
    Heading: {
      buttons: {
        heading: {
          tooltip: function tooltip(_a) {
            var level = _a.level;
            return level + ' level header';
          }
        }
      }
    },
    Link: {
      buttons: {
        isActive: {
          tooltip: 'Change Link'
        },
        notActive: {
          tooltip: 'Add Link'
        }
      },
      window: {
        title: 'Link control',
        form: {
          hrefLabel: 'Href'
        },
        buttons: {
          close: 'Close',
          remove: 'Remove',
          apply: 'Apply'
        }
      }
    },
    Image: {
      buttons: {
        tooltip: 'Image'
      },
      window: {
        title: 'Add Image',
        or: 'OR',
        form: {
          sourceLink: 'Image URL'
        },
        buttons: {
          close: 'Close',
          apply: 'Apply'
        }
      }
    }
  }
};

var ru = {
  extensions: {
    Blockquote: {
      buttons: {
        blockquote: {
          tooltip: 'Блок цитаты'
        }
      }
    },
    Bold: {
      buttons: {
        bold: {
          tooltip: 'Жирный'
        }
      }
    },
    BulletList: {
      buttons: {
        bulletList: {
          tooltip: 'Маркированный список'
        }
      }
    },
    Code: {
      buttons: {
        code: {
          tooltip: 'Код'
        }
      }
    },
    CodeBlock: {
      buttons: {
        codeBlock: {
          tooltip: 'Блок кода'
        }
      }
    },
    History: {
      buttons: {
        undo: {
          tooltip: 'Назад'
        },
        redo: {
          tooltip: 'Вперед'
        }
      }
    },
    HorizontalRule: {
      buttons: {
        horizontalRule: {
          tooltip: 'Горизонтальная линия'
        }
      }
    },
    Italic: {
      buttons: {
        italic: {
          tooltip: 'Курсивный'
        }
      }
    },
    OrderedList: {
      buttons: {
        orderedList: {
          tooltip: 'Упорядоченный список'
        }
      }
    },
    Paragraph: {
      buttons: {
        paragraph: {
          tooltip: 'Параграф'
        }
      }
    },
    Strike: {
      buttons: {
        strike: {
          tooltip: 'Перечерктнутый'
        }
      }
    },
    Underline: {
      buttons: {
        underline: {
          tooltip: 'Подчерктнутый'
        }
      }
    },
    Heading: {
      buttons: {
        heading: {
          tooltip: function tooltip(_a) {
            var level = _a.level;
            return "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A " + level + " \u0443\u0440\u043E\u0432\u043D\u044F";
          }
        }
      }
    },
    Link: {
      buttons: {
        isActive: {
          tooltip: 'Изменить ссылку'
        },
        notActive: {
          tooltip: 'Добавить ссылку'
        }
      },
      window: {
        title: 'Управление ссылкой',
        form: {
          hrefLabel: 'Href'
        },
        buttons: {
          close: 'Закрыть',
          remove: 'Удалить',
          apply: 'Применить'
        }
      }
    },
    Image: {
      buttons: {
        tooltip: 'Картинка'
      },
      window: {
        title: 'Добавить картинку',
        or: 'ИЛИ',
        form: {
          sourceLink: 'Ссылка на картинку'
        },
        buttons: {
          close: 'Закрыть',
          apply: 'Применить'
        }
      }
    }
  }
};

var es = {
  extensions: {
    Blockquote: {
      buttons: {
        blockquote: {
          tooltip: 'Cita en bloque'
        }
      }
    },
    Bold: {
      buttons: {
        bold: {
          tooltip: 'Texto en negrita'
        }
      }
    },
    BulletList: {
      buttons: {
        bulletList: {
          tooltip: 'Lista no ordenada'
        }
      }
    },
    Code: {
      buttons: {
        code: {
          tooltip: 'Código'
        }
      }
    },
    CodeBlock: {
      buttons: {
        codeBlock: {
          tooltip: 'Bloque de código'
        }
      }
    },
    History: {
      buttons: {
        undo: {
          tooltip: 'Deshacer'
        },
        redo: {
          tooltip: 'Rehacer'
        }
      }
    },
    HorizontalRule: {
      buttons: {
        horizontalRule: {
          tooltip: 'Línea horizontal'
        }
      }
    },
    Italic: {
      buttons: {
        italic: {
          tooltip: 'Texto en cursiva'
        }
      }
    },
    OrderedList: {
      buttons: {
        orderedList: {
          tooltip: 'Lista ordenada'
        }
      }
    },
    Paragraph: {
      buttons: {
        paragraph: {
          tooltip: 'Párrafo'
        }
      }
    },
    Strike: {
      buttons: {
        strike: {
          tooltip: 'Tachar texto'
        }
      }
    },
    Underline: {
      buttons: {
        underline: {
          tooltip: 'Subrayar texto'
        }
      }
    },
    Heading: {
      buttons: {
        heading: {
          tooltip: function tooltip(_a) {
            var level = _a.level;
            return "Nivel de encabezado " + level;
          }
        }
      }
    },
    Link: {
      buttons: {
        isActive: {
          tooltip: 'Actualizar enlace'
        },
        notActive: {
          tooltip: 'Añadir enlace'
        }
      },
      window: {
        title: 'Control de enlace',
        form: {
          hrefLabel: 'Href'
        },
        buttons: {
          close: 'Cerrar',
          remove: 'Eliminar',
          apply: 'Aplicar'
        }
      }
    }
  }
};

var pl = {
  extensions: {
    Blockquote: {
      buttons: {
        blockquote: {
          tooltip: 'Blok cytatu'
        }
      }
    },
    Bold: {
      buttons: {
        bold: {
          tooltip: 'Pogrubienie'
        }
      }
    },
    BulletList: {
      buttons: {
        bulletList: {
          tooltip: 'Lista punktów'
        }
      }
    },
    Code: {
      buttons: {
        code: {
          tooltip: 'Kod'
        }
      }
    },
    CodeBlock: {
      buttons: {
        codeBlock: {
          tooltip: 'Blok kodu'
        }
      }
    },
    History: {
      buttons: {
        undo: {
          tooltip: 'Cofnij'
        },
        redo: {
          tooltip: 'Ponów'
        }
      }
    },
    HorizontalRule: {
      buttons: {
        horizontalRule: {
          tooltip: 'Linia pozioma'
        }
      }
    },
    Italic: {
      buttons: {
        italic: {
          tooltip: 'Kursywa'
        }
      }
    },
    OrderedList: {
      buttons: {
        orderedList: {
          tooltip: 'Lista numerowana'
        }
      }
    },
    Paragraph: {
      buttons: {
        paragraph: {
          tooltip: 'Paragraf'
        }
      }
    },
    Strike: {
      buttons: {
        strike: {
          tooltip: 'Przekreślenie'
        }
      }
    },
    Underline: {
      buttons: {
        underline: {
          tooltip: 'Podkreślenie'
        }
      }
    },
    Heading: {
      buttons: {
        heading: {
          tooltip: function tooltip(args) {
            return 'Nagłówek ' + args.level;
          }
        }
      }
    },
    Link: {
      buttons: {
        isActive: {
          tooltip: 'Zaktualizuj odnośnik'
        },
        notActive: {
          tooltip: 'Dodaj odnośnik'
        }
      },
      window: {
        title: 'Odnośnik',
        form: {
          hrefLabel: 'Adres URL'
        },
        buttons: {
          close: 'Zamknij',
          remove: 'Usuń',
          apply: 'Zastosuj'
        }
      }
    },
    Image: {
      buttons: {
        tooltip: 'Obrazek'
      },
      window: {
        title: 'Dodaj obrazek',
        or: 'LUB',
        form: {
          sourceLink: 'Adres URL obrazka'
        },
        buttons: {
          close: 'Zamknij',
          apply: 'Zastosuj'
        }
      }
    }
  }
};

var fr = {
  extensions: {
    Blockquote: {
      buttons: {
        blockquote: {
          tooltip: 'Bloc de citation'
        }
      }
    },
    Bold: {
      buttons: {
        bold: {
          tooltip: 'Gras'
        }
      }
    },
    BulletList: {
      buttons: {
        bulletList: {
          tooltip: 'Liste à puce'
        }
      }
    },
    Code: {
      buttons: {
        code: {
          tooltip: 'Code'
        }
      }
    },
    CodeBlock: {
      buttons: {
        codeBlock: {
          tooltip: 'Bloc de code'
        }
      }
    },
    History: {
      buttons: {
        undo: {
          tooltip: 'Annuler'
        },
        redo: {
          tooltip: 'Rétablir'
        }
      }
    },
    HorizontalRule: {
      buttons: {
        horizontalRule: {
          tooltip: 'Ligne horizontale'
        }
      }
    },
    Italic: {
      buttons: {
        italic: {
          tooltip: 'Italique'
        }
      }
    },
    OrderedList: {
      buttons: {
        orderedList: {
          tooltip: 'Liste ordonnée'
        }
      }
    },
    Paragraph: {
      buttons: {
        paragraph: {
          tooltip: 'Paragraphe'
        }
      }
    },
    Strike: {
      buttons: {
        strike: {
          tooltip: 'Barré'
        }
      }
    },
    Underline: {
      buttons: {
        underline: {
          tooltip: 'Souligné'
        }
      }
    },
    Heading: {
      buttons: {
        heading: {
          tooltip: function tooltip(args) {
            return args.level + ' niveau de titre';
          }
        }
      }
    },
    Link: {
      buttons: {
        isActive: {
          tooltip: 'Mise à jour du lien'
        },
        notActive: {
          tooltip: 'Ajouter un lien'
        }
      },
      window: {
        title: 'Contrôle de lien',
        form: {
          hrefLabel: 'Href'
        },
        buttons: {
          close: 'Fermer',
          remove: 'Retirer',
          apply: 'Appliquer'
        }
      }
    }
  }
};

var uk = {
  extensions: {
    Blockquote: {
      buttons: {
        blockquote: {
          tooltip: 'Блок цитати'
        }
      }
    },
    Bold: {
      buttons: {
        bold: {
          tooltip: 'Жирний'
        }
      }
    },
    BulletList: {
      buttons: {
        bulletList: {
          tooltip: 'Маркований список'
        }
      }
    },
    Code: {
      buttons: {
        code: {
          tooltip: 'Код'
        }
      }
    },
    CodeBlock: {
      buttons: {
        codeBlock: {
          tooltip: 'Блок кода'
        }
      }
    },
    History: {
      buttons: {
        undo: {
          tooltip: 'Назад'
        },
        redo: {
          tooltip: 'Вперед'
        }
      }
    },
    HorizontalRule: {
      buttons: {
        horizontalRule: {
          tooltip: 'Горизонтальна лінія'
        }
      }
    },
    Italic: {
      buttons: {
        italic: {
          tooltip: 'Курсивний'
        }
      }
    },
    OrderedList: {
      buttons: {
        orderedList: {
          tooltip: 'Упорядкований список'
        }
      }
    },
    Paragraph: {
      buttons: {
        paragraph: {
          tooltip: 'Параграф'
        }
      }
    },
    Strike: {
      buttons: {
        strike: {
          tooltip: 'Перекреслений'
        }
      }
    },
    Underline: {
      buttons: {
        underline: {
          tooltip: 'Підкреслений'
        }
      }
    },
    Heading: {
      buttons: {
        heading: {
          tooltip: function tooltip(_a) {
            var level = _a.level;
            return "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A " + level + " \u0440\u0456\u0432\u043D\u044F";
          }
        }
      }
    },
    Link: {
      buttons: {
        isActive: {
          tooltip: 'Змінити посилання'
        },
        notActive: {
          tooltip: 'Додати посилання'
        }
      },
      window: {
        title: 'Управління посиланням',
        form: {
          hrefLabel: 'Href'
        },
        buttons: {
          close: 'Закрити',
          remove: 'Вилучити',
          apply: 'Застосувати'
        }
      }
    }
  }
};

var ptbr = {
  extensions: {
    Blockquote: {
      buttons: {
        blockquote: {
          tooltip: 'Bloco de citação'
        }
      }
    },
    Bold: {
      buttons: {
        bold: {
          tooltip: 'Negrito'
        }
      }
    },
    BulletList: {
      buttons: {
        bulletList: {
          tooltip: 'Lista de pontos'
        }
      }
    },
    Code: {
      buttons: {
        code: {
          tooltip: 'Código'
        }
      }
    },
    CodeBlock: {
      buttons: {
        codeBlock: {
          tooltip: 'Bloco de código'
        }
      }
    },
    History: {
      buttons: {
        undo: {
          tooltip: 'Desfazer'
        },
        redo: {
          tooltip: 'Refazer'
        }
      }
    },
    HorizontalRule: {
      buttons: {
        horizontalRule: {
          tooltip: 'Linha horizontal'
        }
      }
    },
    Italic: {
      buttons: {
        italic: {
          tooltip: 'Itálico'
        }
      }
    },
    OrderedList: {
      buttons: {
        orderedList: {
          tooltip: 'Lista ordenada'
        }
      }
    },
    Paragraph: {
      buttons: {
        paragraph: {
          tooltip: 'Parágrafo'
        }
      }
    },
    Strike: {
      buttons: {
        strike: {
          tooltip: 'Riscado'
        }
      }
    },
    Underline: {
      buttons: {
        underline: {
          tooltip: 'Sublinhado'
        }
      }
    },
    Heading: {
      buttons: {
        heading: {
          tooltip: function tooltip(_a) {
            var level = _a.level;
            return 'cabeçalho nível ' + level;
          }
        }
      }
    },
    Link: {
      buttons: {
        isActive: {
          tooltip: 'Mudar Link'
        },
        notActive: {
          tooltip: 'Adicionar Link'
        }
      },
      window: {
        title: 'Configurar link',
        form: {
          hrefLabel: 'link'
        },
        buttons: {
          close: 'Fechar',
          remove: 'Remover',
          apply: 'Aplicar'
        }
      }
    }
  }
};

var tr = {
  extensions: {
    Blockquote: {
      buttons: {
        blockquote: {
          tooltip: 'Alıntı'
        }
      }
    },
    Bold: {
      buttons: {
        bold: {
          tooltip: 'Kalın'
        }
      }
    },
    BulletList: {
      buttons: {
        bulletList: {
          tooltip: 'Liste'
        }
      }
    },
    Code: {
      buttons: {
        code: {
          tooltip: 'Kod'
        }
      }
    },
    CodeBlock: {
      buttons: {
        codeBlock: {
          tooltip: 'Kod Bloğu'
        }
      }
    },
    History: {
      buttons: {
        undo: {
          tooltip: 'Geri'
        },
        redo: {
          tooltip: 'İleri'
        }
      }
    },
    HorizontalRule: {
      buttons: {
        horizontalRule: {
          tooltip: 'Yatay çizgi'
        }
      }
    },
    Italic: {
      buttons: {
        italic: {
          tooltip: 'İtalik'
        }
      }
    },
    OrderedList: {
      buttons: {
        orderedList: {
          tooltip: 'Numaralı Liste'
        }
      }
    },
    Paragraph: {
      buttons: {
        paragraph: {
          tooltip: 'Paragraf'
        }
      }
    },
    Strike: {
      buttons: {
        strike: {
          tooltip: 'Üstü Çizili'
        }
      }
    },
    Underline: {
      buttons: {
        underline: {
          tooltip: 'Altı Çizili'
        }
      }
    },
    Heading: {
      buttons: {
        heading: {
          tooltip: function tooltip(_a) {
            var level = _a.level;
            return level + ' Başlık';
          }
        }
      }
    },
    Link: {
      buttons: {
        isActive: {
          tooltip: 'Link\'i Düzenle'
        },
        notActive: {
          tooltip: 'Link Ekle'
        }
      },
      window: {
        title: 'Link Kontrol',
        form: {
          hrefLabel: 'Adres'
        },
        buttons: {
          close: 'Kapat',
          remove: 'Sil',
          apply: 'Uygula'
        }
      }
    }
  }
};

var he = {
  extensions: {
    Blockquote: {
      buttons: {
        blockquote: {
          tooltip: 'ציטוט'
        }
      }
    },
    Bold: {
      buttons: {
        bold: {
          tooltip: 'מודגש'
        }
      }
    },
    BulletList: {
      buttons: {
        bulletList: {
          tooltip: 'רשימה לא ממוספרת'
        }
      }
    },
    Code: {
      buttons: {
        code: {
          tooltip: 'קוד'
        }
      }
    },
    CodeBlock: {
      buttons: {
        codeBlock: {
          tooltip: 'בלוק קוד'
        }
      }
    },
    History: {
      buttons: {
        undo: {
          tooltip: 'ביטול'
        },
        redo: {
          tooltip: 'בצע שוב'
        }
      }
    },
    HorizontalRule: {
      buttons: {
        horizontalRule: {
          tooltip: 'קו אופקי'
        }
      }
    },
    Italic: {
      buttons: {
        italic: {
          tooltip: 'מוטה'
        }
      }
    },
    OrderedList: {
      buttons: {
        orderedList: {
          tooltip: 'רשימה ממוספרת'
        }
      }
    },
    Paragraph: {
      buttons: {
        paragraph: {
          tooltip: 'פיסקה'
        }
      }
    },
    Strike: {
      buttons: {
        strike: {
          tooltip: 'קו אמצע'
        }
      }
    },
    Underline: {
      buttons: {
        underline: {
          tooltip: 'קו תחתון'
        }
      }
    },
    Heading: {
      buttons: {
        heading: {
          tooltip: function tooltip(_a) {
            var level = _a.level;
            return level + ' כותרת בגודל';
          }
        }
      }
    },
    Link: {
      buttons: {
        isActive: {
          tooltip: 'שנה קישור'
        },
        notActive: {
          tooltip: 'הוסף קישור'
        }
      },
      window: {
        title: 'ניהול קישור',
        form: {
          hrefLabel: 'כתובת'
        },
        buttons: {
          close: 'סגור',
          remove: 'הסר',
          apply: 'החל'
        }
      }
    }
  }
};

var nl = {
  extensions: {
    Blockquote: {
      buttons: {
        blockquote: {
          tooltip: 'Citaatblok'
        }
      }
    },
    Bold: {
      buttons: {
        bold: {
          tooltip: 'Vet'
        }
      }
    },
    BulletList: {
      buttons: {
        bulletList: {
          tooltip: 'Opsomming tekens'
        }
      }
    },
    Code: {
      buttons: {
        code: {
          tooltip: 'Code'
        }
      }
    },
    CodeBlock: {
      buttons: {
        codeBlock: {
          tooltip: 'Code blok'
        }
      }
    },
    History: {
      buttons: {
        undo: {
          tooltip: 'Ongedaan maken'
        },
        redo: {
          tooltip: 'Opnieuw uitvoeren'
        }
      }
    },
    HorizontalRule: {
      buttons: {
        horizontalRule: {
          tooltip: 'Horizontale lijn'
        }
      }
    },
    Italic: {
      buttons: {
        italic: {
          tooltip: 'Cursief'
        }
      }
    },
    OrderedList: {
      buttons: {
        orderedList: {
          tooltip: 'Genummerde lijst'
        }
      }
    },
    Paragraph: {
      buttons: {
        paragraph: {
          tooltip: 'Paragraaf'
        }
      }
    },
    Strike: {
      buttons: {
        strike: {
          tooltip: 'Doorhalen'
        }
      }
    },
    Underline: {
      buttons: {
        underline: {
          tooltip: 'Onderstrepen'
        }
      }
    },
    Heading: {
      buttons: {
        heading: {
          tooltip: function tooltip(_a) {
            var level = _a.level;
            return 'Kop ' + level;
          }
        }
      }
    },
    Link: {
      buttons: {
        isActive: {
          tooltip: 'Link wijzigigen'
        },
        notActive: {
          tooltip: 'Link invoegen'
        }
      },
      window: {
        title: 'Link controle',
        form: {
          hrefLabel: 'Href'
        },
        buttons: {
          close: 'Sluiten',
          remove: 'Verwijderen',
          apply: 'Toepassen'
        }
      }
    },
    Image: {
      buttons: {
        tooltip: 'Afbeelding'
      },
      window: {
        title: 'Afbeelding toevoegen',
        or: 'OF',
        form: {
          sourceLink: 'Afbeelding URL'
        },
        buttons: {
          close: 'Sluiten',
          apply: 'Toepassen'
        }
      }
    }
  }
};

var ja = {
  extensions: {
    Blockquote: {
      buttons: {
        blockquote: {
          tooltip: '引用'
        }
      }
    },
    Bold: {
      buttons: {
        bold: {
          tooltip: '太字'
        }
      }
    },
    BulletList: {
      buttons: {
        bulletList: {
          tooltip: '箇条書き'
        }
      }
    },
    Code: {
      buttons: {
        code: {
          tooltip: 'コード'
        }
      }
    },
    CodeBlock: {
      buttons: {
        codeBlock: {
          tooltip: 'コードブロック'
        }
      }
    },
    History: {
      buttons: {
        undo: {
          tooltip: '元に戻す'
        },
        redo: {
          tooltip: 'やり直し'
        }
      }
    },
    HorizontalRule: {
      buttons: {
        horizontalRule: {
          tooltip: '平行線'
        }
      }
    },
    Italic: {
      buttons: {
        italic: {
          tooltip: '斜体'
        }
      }
    },
    OrderedList: {
      buttons: {
        orderedList: {
          tooltip: '番号付きリスト'
        }
      }
    },
    Paragraph: {
      buttons: {
        paragraph: {
          tooltip: '段落'
        }
      }
    },
    Strike: {
      buttons: {
        strike: {
          tooltip: '取り消し線'
        }
      }
    },
    Underline: {
      buttons: {
        underline: {
          tooltip: '下線'
        }
      }
    },
    Heading: {
      buttons: {
        heading: {
          tooltip: function tooltip(_a) {
            var level = _a.level;
            return '見出し ' + level;
          }
        }
      }
    },
    Link: {
      buttons: {
        isActive: {
          tooltip: 'リンク変更'
        },
        notActive: {
          tooltip: 'リンク追加'
        }
      },
      window: {
        title: 'リンクの編集',
        form: {
          hrefLabel: 'リンク'
        },
        buttons: {
          close: '閉じる',
          remove: '削除',
          apply: '適用'
        }
      }
    },
    Image: {
      buttons: {
        tooltip: '画像'
      },
      window: {
        title: '画像を追加する',
        or: 'または',
        form: {
          sourceLink: '画像URL'
        },
        buttons: {
          close: '閉じる',
          apply: '適用'
        }
      }
    }
  }
};

var de = {
  extensions: {
    Blockquote: {
      buttons: {
        blockquote: {
          tooltip: 'Block Zitat'
        }
      }
    },
    Bold: {
      buttons: {
        bold: {
          tooltip: 'Fett'
        }
      }
    },
    BulletList: {
      buttons: {
        bulletList: {
          tooltip: 'Aufzählungsliste'
        }
      }
    },
    Code: {
      buttons: {
        code: {
          tooltip: 'Code'
        }
      }
    },
    CodeBlock: {
      buttons: {
        codeBlock: {
          tooltip: 'Code Abschnitt'
        }
      }
    },
    History: {
      buttons: {
        undo: {
          tooltip: 'Rückgängig'
        },
        redo: {
          tooltip: 'Wiederherstellen'
        }
      }
    },
    HorizontalRule: {
      buttons: {
        horizontalRule: {
          tooltip: 'Horizontale Linie'
        }
      }
    },
    Italic: {
      buttons: {
        italic: {
          tooltip: 'Kursiv'
        }
      }
    },
    OrderedList: {
      buttons: {
        orderedList: {
          tooltip: 'Geordnete Liste'
        }
      }
    },
    Paragraph: {
      buttons: {
        paragraph: {
          tooltip: 'Paragraph'
        }
      }
    },
    Strike: {
      buttons: {
        strike: {
          tooltip: 'Durchgestrichen'
        }
      }
    },
    Underline: {
      buttons: {
        underline: {
          tooltip: 'Unterstreichen'
        }
      }
    },
    Heading: {
      buttons: {
        heading: {
          tooltip: function tooltip(_a) {
            var level = _a.level;
            return level + ' level Überschrift';
          }
        }
      }
    },
    Link: {
      buttons: {
        isActive: {
          tooltip: 'Link ändern'
        },
        notActive: {
          tooltip: 'Link hinzufügen'
        }
      },
      window: {
        title: 'Link Kontrolle',
        form: {
          hrefLabel: 'Href'
        },
        buttons: {
          close: 'Schließen',
          remove: 'Entfernen',
          apply: 'Übernehmen'
        }
      }
    },
    Image: {
      buttons: {
        tooltip: 'Bild'
      },
      window: {
        title: 'Bild hinzufügen',
        or: 'ODER',
        form: {
          sourceLink: 'Bild URL'
        },
        buttons: {
          close: 'Schließen',
          apply: 'Übernehmen'
        }
      }
    }
  }
};

var ConsoleLogger =
/** @class */
function () {
  function ConsoleLogger() {}

  ConsoleLogger.prototype.warn = function (msg) {
    console.warn(PACKAGE_NAME + ": " + msg);
  };

  ConsoleLogger.prototype.error = function (msg) {
    console.error(PACKAGE_NAME + ": " + msg);
  };

  return ConsoleLogger;
}();

var ConsoleLogger$1 = new ConsoleLogger();

var defaultLanguage = 'en';
var dictionary = {
  en: en,
  ru: ru,
  es: es,
  pl: pl,
  fr: fr,
  uk: uk,
  ptbr: ptbr,
  tr: tr,
  he: he,
  nl: nl,
  ja: ja,
  de: de
};
function getCurrentLang() {
  return TiptapVuetifyPlugin.vuetifyLang || defaultLanguage;
}
function getMsg(path, args, lang) {
  if (lang === void 0) {
    lang = null;
  }

  var currentLang = lang || getCurrentLang();

  if (!dictionary[currentLang]) {
    currentLang = defaultLanguage;
    ConsoleLogger$1.warn("The current language \"" + currentLang + "\" is not yet available. Using language \"" + defaultLanguage + "\" by default. Contribution to github is welcome.");
  }

  var dictionaryByLang = dictionary[currentLang];
  var target;

  try {
    target = path.split('.').reduce(function (prev, curr) {
      return prev[curr];
    }, dictionaryByLang);
  } catch (e) {
    ConsoleLogger$1.warn("Cannot get translation \"" + path + "\" for language \"" + currentLang + "\". Fallback \"" + defaultLanguage + "\" is used instead. Contribution to github is welcome."); // Использовать defaultLanguage если фраза не переведена на текущий язык

    return getMsg(path, args, defaultLanguage);
  }

  if (target instanceof Function) {
    return target(args);
  }

  return target;
}

var namespace = '$i18n';

var I18nMixin =
/** @class */
function (_super) {
  __extends(I18nMixin, _super);

  function I18nMixin() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(I18nMixin.prototype, namespace, {
    get: function get() {
      return {
        getMsg: getMsg
      };
    },
    enumerable: true,
    configurable: true
  });
  I18nMixin = __decorate([Component], I18nMixin);
  return I18nMixin;
}(Vue);

var Menu =
/** @class */
function (_super) {
  __extends(Menu, _super);

  function Menu() {
    return _super !== null && _super.apply(this, arguments) || this;
  } // linkUrl: null | string = null
  // linkMenuIsActive: null | boolean = false


  Menu.prototype.getMenuY = function (menu) {
    // высота всей страницы - высота окна - сколько страницу прокрученно от верха
    var diff = document.documentElement.scrollHeight - window.innerHeight - window.scrollY; // bottom позиция относитель низа окна

    var bottomRelatedToWindow = menu.bottom - diff; // top позиция

    return window.innerHeight - bottomRelatedToWindow + 15; // + 15 из-за того что bottom, если top, то не нужно
  };

  Menu.prototype.getBubbleContentStyle = function (context) {
    return {
      display: context.menu.isActive ? 'block' : 'none',
      // иначе не видно
      zIndex: 1,
      position: 'absolute',
      left: context.menu.left + 'px',
      bottom: context.menu.bottom + 'px'
    };
  };

  __decorate([Prop({
    type: Object,
    required: true
  }), __metadata("design:type", Editor)], Menu.prototype, "editor", void 0);

  __decorate([Prop({
    type: Array,
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], Menu.prototype, "actions", void 0);

  Menu = __decorate([Component({
    components: {
      ActionsRender: ActionsRender$1,
      EditorMenuBubble: EditorMenuBubble,
      VCard: VCard
    }
  })], Menu);
  return Menu;
}(mixins(I18nMixin));

/* script */
const __vue_script__$3 = Menu;
/* template */
var __vue_render__$3 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('editor-menu-bubble',{staticClass:"tiptap-vuetify-editor__menububble",attrs:{"editor":_vm.editor,"keep-in-bounds":true},scopedSlots:_vm._u([{key:"default",fn:function(context){return [_c('div',[_c('v-card',{staticClass:"tiptap-vuetify-editor__menububble-card",style:(_vm.getBubbleContentStyle(context)),attrs:{"dark":""}},[_c('actions-render',{attrs:{"actions":_vm.actions,"context":context,"editor":_vm.editor,"dark":true}})],1)],1)]}}])})};
var __vue_staticRenderFns__$3 = [];

  /* style */
  const __vue_inject_styles__$3 = undefined;
  /* scoped */
  const __vue_scope_id__$3 = undefined;
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Bubble = normalizeComponent_1(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    undefined,
    undefined
  );

var ExtensionActionRenderInEnum;

(function (ExtensionActionRenderInEnum) {
  ExtensionActionRenderInEnum["toolbar"] = "toolbar";
  ExtensionActionRenderInEnum["bubbleMenu"] = "bubbleMenu";
})(ExtensionActionRenderInEnum || (ExtensionActionRenderInEnum = {}));

var TiptapVuetify =
/** @class */
function (_super) {
  __extends(TiptapVuetify, _super);

  function TiptapVuetify() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.PROPS = PROPS$2;
    _this.EDITOR_TYPES_ENUM = EDITOR_TYPES_ENUM;
    _this.editor = null;
    _this.availableActions = {
      toolbar: [],
      bubbleMenu: []
    };
    _this.emitAfterOnUpdate = false;
    return _this;
  }

  Object.defineProperty(TiptapVuetify.prototype, "contentDynamicStyles", {
    get: function get() {
      // если не указана еденица измерения (e.g. 60, 25), то будет как px. То есть 60em, 25% такими и останетутся.
      var getUnitWithPxAsDefault = function getUnitWithPxAsDefault(str) {
        if (!str) return str;
        var num = parseInt(str, 10);
        var unit = str.slice(num.toString().length);
        return num + (unit || 'px');
      };

      return {
        minHeight: getUnitWithPxAsDefault(this[PROPS$2.MIN_HEIGHT]),
        maxHeight: getUnitWithPxAsDefault(this[PROPS$2.MAX_HEIGHT])
      };
    },
    enumerable: true,
    configurable: true
  });

  TiptapVuetify.prototype.onValueChange = function (val) {
    if (this.emitAfterOnUpdate) {
      this.emitAfterOnUpdate = false;
      return;
    }

    if (this.editor) this.editor.setContent(val);
  };

  TiptapVuetify.prototype.mounted = function () {
    var _this = this;

    var nativeExtensionsInstances = []; // опции расширений по умолчанию

    var paramsDefault = {
      renderIn: ExtensionActionRenderInEnum.toolbar,
      options: {}
    };
    this[PROPS$2.EXTENSIONS].forEach(function (extensionDefinition) {
      var _m, _o;

      var ExtensionClass;
      var params; // Получение расширения и его опций

      if (Array.isArray(extensionDefinition)) {
        _m = __read(extensionDefinition, 2), ExtensionClass = _m[0], params = _m[1]; // TODO улучшить проверку, но почему-то это не работает: http://bit.ly/2ALqFJB
      } else if (extensionDefinition.prototype.availableActions) {
        // Если extends от AbstractExtension
        ExtensionClass = extensionDefinition;
      } else {
        throw new Error('Incorrect extension declaration passed to "extensions" prop (array). ' + 'It looks like the array\'s element is in the wrong format.');
      } // параметры с дефолтными значениями TODO deep merge


      var paramsFinal = __assign(__assign({}, paramsDefault), params);

      var extension = new ExtensionClass(paramsFinal.options); // const renderInVariants = Object.values(ExtensionActionRenderInEnum)
      //
      // if (!renderInVariants.includes(options.renderIn)) {
      //   throw new Error('Please, set the "renderIn" option to one of following values: ' + renderInVariants)
      // }
      // пополнение доступных действий для конкретного renderIn

      (_o = _this.availableActions[paramsFinal.renderIn]).push.apply(_o, __spread(extension.availableActions)); // Сбор нативных расширений


      if (extension.nativeExtensionInstance) {
        nativeExtensionsInstances.push(extension.nativeExtensionInstance);
      }
    });

    var extensions = __spread(this[PROPS$2.NATIVE_EXTENSIONS], nativeExtensionsInstances);

    if (this[PROPS$2.PLACEHOLDER]) {
      // !!!!!!!!!!!!!!!!! TODO ONLY FOR TEST (update: не помню что это, возможно и не нужно убирать код ниже)
      extensions.push(new Placeholder({
        emptyNodeClass: 'tiptap-vuetify-editor__paragraph--is-empty',
        emptyNodeText: this[PROPS$2.PLACEHOLDER],
        showOnlyWhenEditable: true
      }));
    }

    this.editor = new Editor(__assign(__assign({
      extensions: extensions
    }, this[PROPS$2.EDITOR_PROPERTIES]), {
      editorProps: __assign(__assign({}, this[PROPS$2.EDITOR_PROPERTIES].editorProps), {
        handleKeyDown: function handleKeyDown(view, event) {
          if (_this[PROPS$2.EDITOR_PROPERTIES].editorProps && _this[PROPS$2.EDITOR_PROPERTIES].editorProps.handleKeyDown) {
            _this[PROPS$2.EDITOR_PROPERTIES].editorProps.handleKeyDown(view, event);
          }

          _this.$emit('keydown', event, view);
        }
      }),
      content: this[PROPS$2.VALUE],
      onUpdate: this.onUpdate.bind(this)
    }));
    this.$emit(EVENTS.INIT, {
      editor: this.editor
    });
  };

  TiptapVuetify.prototype.onUpdate = function (info) {
    this.emitAfterOnUpdate = true;
    var output;

    if (this[PROPS$2.OUTPUT_FORMAT] === 'html') {
      output = info.getHTML();
    } else {
      output = JSON.stringify(info.getJSON());
    }

    this.$emit(EVENTS.INPUT, output, info);
  };

  TiptapVuetify.prototype.beforeDestroy = function () {
    if (this.editor) this.editor.destroy();
  };

  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;

  _a = PROPS$2.VALUE, _b = PROPS$2.EXTENSIONS, _c = PROPS$2.PLACEHOLDER, _d = PROPS$2.CARD_PROPS, _e = PROPS$2.OUTPUT_FORMAT, _f = PROPS$2.TOOLBAR_ATTRIBUTES, _g = PROPS$2.EDITOR_PROPERTIES, _h = PROPS$2.NATIVE_EXTENSIONS, _j = PROPS$2.TYPE, _k = PROPS$2.MIN_HEIGHT, _l = PROPS$2.MAX_HEIGHT;

  __decorate([Prop({
    type: String,
    default: ''
  }), __metadata("design:type", String)], TiptapVuetify.prototype, _a, void 0);

  __decorate([Prop({
    type: Array,
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], TiptapVuetify.prototype, _b, void 0);

  __decorate([Prop({
    type: String
  }), __metadata("design:type", String)], TiptapVuetify.prototype, _c, void 0);

  __decorate([Prop({
    type: Object,
    default: function _default() {
      return {};
    }
  }), __metadata("design:type", Object)], TiptapVuetify.prototype, _d, void 0);

  __decorate([Prop({
    type: String,
    default: 'html'
  }), __metadata("design:type", String)], TiptapVuetify.prototype, _e, void 0);

  __decorate([Prop({
    type: [Array, Object],
    default: function _default() {
      return {};
    }
  }), __metadata("design:type", Object)], TiptapVuetify.prototype, _f, void 0);

  __decorate([Prop({
    type: Object,
    default: function _default() {
      return {};
    }
  }), __metadata("design:type", Object)], TiptapVuetify.prototype, _g, void 0);

  __decorate([Prop({
    type: Array,
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], TiptapVuetify.prototype, _h, void 0);

  __decorate([Prop({
    type: String,
    default: EDITOR_TYPES_ENUM.card
  }), __metadata("design:type", String)], TiptapVuetify.prototype, _j, void 0);

  __decorate([Prop({
    type: [String, Number]
  }), __metadata("design:type", Object)], TiptapVuetify.prototype, _k, void 0);

  __decorate([Prop({
    type: [String, Number]
  }), __metadata("design:type", Object)], TiptapVuetify.prototype, _l, void 0);

  __decorate([Watch('value'), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], TiptapVuetify.prototype, "onValueChange", null);

  TiptapVuetify = __decorate([Component({
    components: {
      Bubble: Bubble,
      EditorContent: EditorContent,
      Toolbar: Toolbar$1,
      VCard: VCard
    }
  })], TiptapVuetify);
  return TiptapVuetify;
}(Vue);

/* script */
const __vue_script__$4 = TiptapVuetify;
/* template */
var __vue_render__$4 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.editor)?_c('div',{staticClass:"tiptap-vuetify-editor"},[(_vm.availableActions.bubbleMenu.length)?_c('bubble',{attrs:{"editor":_vm.editor,"actions":_vm.availableActions.bubbleMenu}}):_vm._e(),_vm._v(" "),(_vm.$props[_vm.PROPS.TYPE] === _vm.EDITOR_TYPES_ENUM.card)?_c('VCard',_vm._b({},'VCard',_vm.$props[_vm.PROPS.CARD_PROPS],false),[_vm._t("toolbar-before"),_vm._v(" "),(_vm.availableActions.toolbar.length)?_c('toolbar',{attrs:{"editor":_vm.editor,"actions":_vm.availableActions.toolbar,"toolbar-attributes":_vm.$props[_vm.PROPS.TOOLBAR_ATTRIBUTES]},scopedSlots:_vm._u([(_vm.$scopedSlots.toolbar)?{key:"default",fn:function(scopedSlot){return [_vm._t("toolbar",null,null,scopedSlot)]}}:null],null,true)}):_vm._e(),_vm._v(" "),_vm._t("toolbar-after"),_vm._v(" "),_c('editor-content',{staticClass:"tiptap-vuetify-editor__content",style:(_vm.contentDynamicStyles),attrs:{"editor":_vm.editor}}),_vm._v(" "),_vm._t("footer")],2):_vm._e()],1):_vm._e()};
var __vue_staticRenderFns__$4 = [];

  /* style */
  const __vue_inject_styles__$4 = undefined;
  /* scoped */
  const __vue_scope_id__$4 = undefined;
  /* module identifier */
  const __vue_module_identifier__$4 = undefined;
  /* functional template */
  const __vue_is_functional_template__$4 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var TiptapVuetify$1 = normalizeComponent_1(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    undefined,
    undefined
  );

var theme = {
  defaultIconsGroup: "md"
  /* md */

};

var $map = arrayIteration.map;


// `Array.prototype.map` method
// https://tc39.github.io/ecma262/#sec-array.prototype.map
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !arrayMethodHasSpeciesSupport('map') }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var I18nText =
/** @class */
function () {
  function I18nText(path, args) {
    this.text = getMsg(path, args);
  }

  I18nText.prototype.toString = function () {
    return this.text;
  };

  return I18nText;
}();

var AbstractExtension =
/** @class */
function () {
  function AbstractExtension(options, extensionClass) {
    this.options = options;
    this.extensionClass = extensionClass;
    this.nativeExtensionInstance = null;

    if (extensionClass) {
      // eslint-disable-next-line
      this.nativeExtensionInstance = new extensionClass(options);
    }
  }

  return AbstractExtension;
}();

var Heading =
/** @class */
function (_super) {
  __extends(Heading, _super);

  function Heading(options) {
    return _super.call(this, options, Heading$1) || this;
  }

  Object.defineProperty(Heading.prototype, "availableActions", {
    get: function get() {
      return this.options.levels.map(function (level) {
        var _a;

        return {
          render: new ExtensionActionRenderBtn$1({
            tooltip: new I18nText('extensions.Heading.buttons.heading.tooltip', {
              level: level
            }),
            icons: (_a = {}, _a["md"
            /* md */
            ] = new TextIcon('H' + level), _a["fa"
            /* fa */
            ] = new TextIcon('H' + level), _a["mdi"
            /* mdi */
            ] = new TextIcon('H' + level), _a["mdiSvg"
            /* mdiSvg */
            ] = new TextIcon('H' + level), _a),
            nativeExtensionName: 'heading',
            onClickOptions: {
              level: level
            },
            isActiveOptions: {
              level: level
            }
          })
        };
      });
    },
    enumerable: true,
    configurable: true
  });
  return Heading;
}(AbstractExtension);

var Bold =
/** @class */
function (_super) {
  __extends(Bold, _super);

  function Bold(options) {
    return _super.call(this, options, Bold$1) || this;
  }

  Object.defineProperty(Bold.prototype, "availableActions", {
    get: function get() {
      var _a;

      return [{
        render: new ExtensionActionRenderBtn$1({
          tooltip: new I18nText('extensions.Bold.buttons.bold.tooltip'),
          icons: (_a = {}, _a["md"
          /* md */
          ] = new VuetifyIcon('format_bold'), _a["fa"
          /* fa */
          ] = new VuetifyIcon('fas fa-bold'), _a["mdi"
          /* mdi */
          ] = new VuetifyIcon('mdi-format-bold'), _a["mdiSvg"
          /* mdiSvg */
          ] = new VuetifyIcon('M13.5,15.5H10V12.5H13.5A1.5,1.5 0 0,1 15,14A1.5,1.5 0 0,1 13.5,15.5M10,6.5H13A1.5,1.5 0 0,1 14.5,8A1.5,1.5 0 0,1 13,9.5H10M15.6,10.79C16.57,10.11 17.25,9 17.25,8C17.25,5.74 15.5,4 13.25,4H7V18H14.04C16.14,18 17.75,16.3 17.75,14.21C17.75,12.69 16.89,11.39 15.6,10.79Z'), _a),
          nativeExtensionName: 'bold'
        })
      }];
    },
    enumerable: true,
    configurable: true
  });
  return Bold;
}(AbstractExtension);

var Italic =
/** @class */
function (_super) {
  __extends(Italic, _super);

  function Italic(options) {
    return _super.call(this, options, Italic$1) || this;
  }

  Object.defineProperty(Italic.prototype, "availableActions", {
    get: function get() {
      var _a;

      return [{
        render: new ExtensionActionRenderBtn$1({
          tooltip: new I18nText('extensions.Italic.buttons.italic.tooltip'),
          icons: (_a = {}, _a["md"
          /* md */
          ] = new VuetifyIcon('format_italic'), _a["fa"
          /* fa */
          ] = new VuetifyIcon('fas fa-italic'), _a["mdi"
          /* mdi */
          ] = new VuetifyIcon('mdi-format-italic'), _a["mdiSvg"
          /* mdiSvg */
          ] = new VuetifyIcon('M10,4V7H12.21L8.79,15H6V18H14V15H11.79L15.21,7H18V4H10Z'), _a),
          nativeExtensionName: 'italic'
        })
      }];
    },
    enumerable: true,
    configurable: true
  });
  return Italic;
}(AbstractExtension);

var Strike =
/** @class */
function (_super) {
  __extends(Strike, _super);

  function Strike(options) {
    return _super.call(this, options, Strike$1) || this;
  }

  Object.defineProperty(Strike.prototype, "availableActions", {
    get: function get() {
      var _a;

      return [{
        render: new ExtensionActionRenderBtn$1({
          tooltip: new I18nText('extensions.Strike.buttons.strike.tooltip'),
          icons: (_a = {}, _a["md"
          /* md */
          ] = new VuetifyIcon('format_strikethrough'), _a["fa"
          /* fa */
          ] = new VuetifyIcon('fas fa-strikethrough'), _a["mdi"
          /* mdi */
          ] = new VuetifyIcon('mdi-format-strikethrough'), _a["mdiSvg"
          /* mdiSvg */
          ] = new VuetifyIcon('M3,14H21V12H3M5,4V7H10V10H14V7H19V4M10,19H14V16H10V19Z'), _a),
          nativeExtensionName: 'strike'
        })
      }];
    },
    enumerable: true,
    configurable: true
  });
  return Strike;
}(AbstractExtension);

var Underline =
/** @class */
function (_super) {
  __extends(Underline, _super);

  function Underline(options) {
    return _super.call(this, options, Underline$1) || this;
  }

  Object.defineProperty(Underline.prototype, "availableActions", {
    get: function get() {
      var _a;

      return [{
        render: new ExtensionActionRenderBtn$1({
          tooltip: new I18nText('extensions.Underline.buttons.underline.tooltip'),
          icons: (_a = {}, _a["md"
          /* md */
          ] = new VuetifyIcon('format_underline'), _a["fa"
          /* fa */
          ] = new VuetifyIcon('fas fa-underline'), _a["mdi"
          /* mdi */
          ] = new VuetifyIcon('mdi-format-underline'), _a["mdiSvg"
          /* mdiSvg */
          ] = new VuetifyIcon('M5,21H19V19H5V21M12,17A6,6 0 0,0 18,11V3H15.5V11A3.5,3.5 0 0,1 12,14.5A3.5,3.5 0 0,1 8.5,11V3H6V11A6,6 0 0,0 12,17Z'), _a),
          nativeExtensionName: 'underline'
        })
      }];
    },
    enumerable: true,
    configurable: true
  });
  return Underline;
}(AbstractExtension);

var Code =
/** @class */
function (_super) {
  __extends(Code, _super);

  function Code(options) {
    return _super.call(this, options, Code$1) || this;
  }

  Object.defineProperty(Code.prototype, "availableActions", {
    get: function get() {
      var _a;

      return [{
        render: new ExtensionActionRenderBtn$1({
          tooltip: new I18nText('extensions.Code.buttons.code.tooltip'),
          icons: (_a = {}, _a["md"
          /* md */
          ] = new VuetifyIcon('code'), _a["fa"
          /* fa */
          ] = new VuetifyIcon('fas fa-code'), _a["mdi"
          /* mdi */
          ] = new VuetifyIcon('mdi-code-tags'), _a["mdiSvg"
          /* mdiSvg */
          ] = new VuetifyIcon('M14.6,16.6L19.2,12L14.6,7.4L16,6L22,12L16,18L14.6,16.6M9.4,16.6L4.8,12L9.4,7.4L8,6L2,12L8,18L9.4,16.6Z'), _a),
          nativeExtensionName: 'code'
        })
      }];
    },
    enumerable: true,
    configurable: true
  });
  return Code;
}(AbstractExtension);

var CodeBlock =
/** @class */
function (_super) {
  __extends(CodeBlock, _super);

  function CodeBlock(options) {
    return _super.call(this, options, CodeBlock$1) || this;
  }

  Object.defineProperty(CodeBlock.prototype, "availableActions", {
    get: function get() {
      var _a;

      return [{
        render: new ExtensionActionRenderBtn$1({
          tooltip: new I18nText('extensions.CodeBlock.buttons.codeBlock.tooltip'),
          icons: (_a = {}, _a["md"
          /* md */
          ] = new VuetifyIcon('code'), _a["fa"
          /* fa */
          ] = new VuetifyIcon('fas fa-code'), _a["mdi"
          /* mdi */
          ] = new VuetifyIcon('mdi-code-tags'), _a["mdiSvg"
          /* mdiSvg */
          ] = new VuetifyIcon('M14.6,16.6L19.2,12L14.6,7.4L16,6L22,12L16,18L14.6,16.6M9.4,16.6L4.8,12L9.4,7.4L8,6L2,12L8,18L9.4,16.6Z'), _a),
          nativeExtensionName: 'code_block'
        })
      }];
    },
    enumerable: true,
    configurable: true
  });
  return CodeBlock;
}(AbstractExtension);

var Paragraph =
/** @class */
function (_super) {
  __extends(Paragraph, _super);

  function Paragraph(options) {
    return _super.call(this, options, null) || this;
  }

  Object.defineProperty(Paragraph.prototype, "availableActions", {
    get: function get() {
      var _a;

      return [{
        render: new ExtensionActionRenderBtn$1({
          tooltip: new I18nText('extensions.Paragraph.buttons.paragraph.tooltip'),
          icons: (_a = {}, _a["md"
          /* md */
          ] = new VuetifyIcon('format_textdirection_l_to_r'), _a["fa"
          /* fa */
          ] = new VuetifyIcon('fas fa-paragraph'), _a["mdi"
          /* mdi */
          ] = new VuetifyIcon('mdi-format-paragraph'), _a["mdiSvg"
          /* mdiSvg */
          ] = new VuetifyIcon('M13,4A4,4 0 0,1 17,8A4,4 0 0,1 13,12H11V18H9V4H13M13,10A2,2 0 0,0 15,8A2,2 0 0,0 13,6H11V10H13Z'), _a),
          nativeExtensionName: 'paragraph'
        })
      }];
    },
    enumerable: true,
    configurable: true
  });
  return Paragraph;
}(AbstractExtension);

var BulletList =
/** @class */
function (_super) {
  __extends(BulletList, _super);

  function BulletList(options) {
    return _super.call(this, options, BulletList$1) || this;
  }

  Object.defineProperty(BulletList.prototype, "availableActions", {
    get: function get() {
      var _a;

      return [{
        render: new ExtensionActionRenderBtn$1({
          tooltip: new I18nText('extensions.BulletList.buttons.bulletList.tooltip'),
          icons: (_a = {}, _a["md"
          /* md */
          ] = new VuetifyIcon('format_list_bulleted'), _a["fa"
          /* fa */
          ] = new VuetifyIcon('fas fa-list-ul'), _a["mdi"
          /* mdi */
          ] = new VuetifyIcon('mdi-format-list-bulleted'), _a["mdiSvg"
          /* mdiSvg */
          ] = new VuetifyIcon('M7,5H21V7H7V5M7,13V11H21V13H7M4,4.5A1.5,1.5 0 0,1 5.5,6A1.5,1.5 0 0,1 4,7.5A1.5,1.5 0 0,1 2.5,6A1.5,1.5 0 0,1 4,4.5M4,10.5A1.5,1.5 0 0,1 5.5,12A1.5,1.5 0 0,1 4,13.5A1.5,1.5 0 0,1 2.5,12A1.5,1.5 0 0,1 4,10.5M7,19V17H21V19H7M4,16.5A1.5,1.5 0 0,1 5.5,18A1.5,1.5 0 0,1 4,19.5A1.5,1.5 0 0,1 2.5,18A1.5,1.5 0 0,1 4,16.5Z'), _a),
          nativeExtensionName: 'bullet_list'
        })
      }];
    },
    enumerable: true,
    configurable: true
  });
  return BulletList;
}(AbstractExtension);

var OrderedList =
/** @class */
function (_super) {
  __extends(OrderedList, _super);

  function OrderedList(options) {
    return _super.call(this, options, OrderedList$1) || this;
  }

  Object.defineProperty(OrderedList.prototype, "availableActions", {
    get: function get() {
      var _a;

      return [{
        render: new ExtensionActionRenderBtn$1({
          tooltip: new I18nText('extensions.OrderedList.buttons.orderedList.tooltip'),
          icons: (_a = {}, _a["md"
          /* md */
          ] = new VuetifyIcon('format_list_numbered'), _a["fa"
          /* fa */
          ] = new VuetifyIcon('fas fa-list-ol'), _a["mdi"
          /* mdi */
          ] = new VuetifyIcon('mdi-format-list-numbered'), _a["mdiSvg"
          /* mdiSvg */
          ] = new VuetifyIcon('M7,13V11H21V13H7M7,19V17H21V19H7M7,7V5H21V7H7M3,8V5H2V4H4V8H3M2,17V16H5V20H2V19H4V18.5H3V17.5H4V17H2M4.25,10A0.75,0.75 0 0,1 5,10.75C5,10.95 4.92,11.14 4.79,11.27L3.12,13H5V14H2V13.08L4,11H2V10H4.25Z'), _a),
          nativeExtensionName: 'ordered_list'
        })
      }];
    },
    enumerable: true,
    configurable: true
  });
  return OrderedList;
}(AbstractExtension);

var ListItem =
/** @class */
function (_super) {
  __extends(ListItem, _super);

  function ListItem(options) {
    return _super.call(this, options, ListItem$1) || this;
  }

  Object.defineProperty(ListItem.prototype, "availableActions", {
    get: function get() {
      return [];
    },
    enumerable: true,
    configurable: true
  });
  return ListItem;
}(AbstractExtension);

var Blockquote =
/** @class */
function (_super) {
  __extends(Blockquote, _super);

  function Blockquote(options) {
    return _super.call(this, options, Blockquote$1) || this;
  }

  Object.defineProperty(Blockquote.prototype, "availableActions", {
    get: function get() {
      var _a;

      return [{
        render: new ExtensionActionRenderBtn$1({
          tooltip: new I18nText('extensions.Blockquote.buttons.blockquote.tooltip'),
          icons: (_a = {}, _a["md"
          /* md */
          ] = new VuetifyIcon('format_quote'), _a["fa"
          /* fa */
          ] = new VuetifyIcon('fas fa-quote-right'), _a["mdi"
          /* mdi */
          ] = new VuetifyIcon('mdi-format-quote-close'), _a["mdiSvg"
          /* mdiSvg */
          ] = new VuetifyIcon('M14,17H17L19,13V7H13V13H16M6,17H9L11,13V7H5V13H8L6,17Z'), _a),
          nativeExtensionName: 'blockquote'
        })
      }];
    },
    enumerable: true,
    configurable: true
  });
  return Blockquote;
}(AbstractExtension);

var HardBreak =
/** @class */
function (_super) {
  __extends(HardBreak, _super);

  function HardBreak(options) {
    return _super.call(this, options, HardBreak$1) || this;
  }

  Object.defineProperty(HardBreak.prototype, "availableActions", {
    get: function get() {
      return [];
    },
    enumerable: true,
    configurable: true
  });
  return HardBreak;
}(AbstractExtension);

var HorizontalRule =
/** @class */
function (_super) {
  __extends(HorizontalRule, _super);

  function HorizontalRule(options) {
    return _super.call(this, options, HorizontalRule$1) || this;
  }

  Object.defineProperty(HorizontalRule.prototype, "availableActions", {
    get: function get() {
      var _a;

      return [{
        render: new ExtensionActionRenderBtn$1({
          tooltip: new I18nText('extensions.HorizontalRule.buttons.horizontalRule.tooltip'),
          icons: (_a = {}, _a["md"
          /* md */
          ] = new TextIcon('—'), _a["fa"
          /* fa */
          ] = new VuetifyIcon('fas fa-minus'), _a["mdi"
          /* mdi */
          ] = new VuetifyIcon('mdi-minus'), _a["mdiSvg"
          /* mdiSvg */
          ] = new VuetifyIcon('M19,13H5V11H19V13Z'), _a),
          nativeExtensionName: 'horizontal_rule'
        })
      }];
    },
    enumerable: true,
    configurable: true
  });
  return HorizontalRule;
}(AbstractExtension);

var History =
/** @class */
function (_super) {
  __extends(History, _super);

  function History(options) {
    return _super.call(this, options, History$1) || this;
  }

  Object.defineProperty(History.prototype, "availableActions", {
    get: function get() {
      var _a, _b; // если не нужны кнокпи


      if (this.options && this.options.noActions) return [];
      return [{
        render: new ExtensionActionRenderBtn$1({
          tooltip: new I18nText('extensions.History.buttons.undo.tooltip'),
          icons: (_a = {}, _a["md"
          /* md */
          ] = new VuetifyIcon('undo'), _a["fa"
          /* fa */
          ] = new VuetifyIcon('fas fa-undo'), _a["mdi"
          /* mdi */
          ] = new VuetifyIcon('mdi-undo'), _a["mdiSvg"
          /* mdiSvg */
          ] = new VuetifyIcon('M12.5,8C9.85,8 7.45,9 5.6,10.6L2,7V16H11L7.38,12.38C8.77,11.22 10.54,10.5 12.5,10.5C16.04,10.5 19.05,12.81 20.1,16L22.47,15.22C21.08,11.03 17.15,8 12.5,8Z'), _a),
          nativeExtensionName: 'undo'
        })
      }, {
        render: new ExtensionActionRenderBtn$1({
          tooltip: new I18nText('extensions.History.buttons.redo.tooltip'),
          icons: (_b = {}, _b["md"
          /* md */
          ] = new VuetifyIcon('redo'), _b["fa"
          /* fa */
          ] = new VuetifyIcon('fas fa-redo'), _b["mdi"
          /* mdi */
          ] = new VuetifyIcon('mdi-redo'), _b["mdiSvg"
          /* mdiSvg */
          ] = new VuetifyIcon('M18.4,10.6C16.55,9 14.15,8 11.5,8C6.85,8 2.92,11.03 1.54,15.22L3.9,16C4.95,12.81 7.95,10.5 11.5,10.5C13.45,10.5 15.23,11.22 16.62,12.38L13,16H22V7L18.4,10.6Z'), _b),
          nativeExtensionName: 'redo'
        })
      }];
    },
    enumerable: true,
    configurable: true
  });
  return History;
}(AbstractExtension);

var PROPS$3 = {
  VALUE: 'value',
  CONTEXT: 'context',
  EDITOR: 'editor',
  NATIVE_EXTENSION_NAME: 'nativeExtensionName',
  HREF: 'href'
};

var LinkWindow =
/** @class */
function (_super) {
  __extends(LinkWindow, _super);

  function LinkWindow() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.form = {
      href: _this[PROPS$3.HREF],
      blank: false
    };
    return _this;
  }

  Object.defineProperty(LinkWindow.prototype, "isRemove", {
    get: function get() {
      return this[PROPS$3.HREF] && !this.form.href;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(LinkWindow.prototype, "isDisabled", {
    get: function get() {
      return this[PROPS$3.HREF] === this.form.href || !this[PROPS$3.HREF] && !this.form.href;
    },
    enumerable: true,
    configurable: true
  });

  LinkWindow.prototype.apply = function () {
    this[PROPS$3.CONTEXT].commands[this[PROPS$3.NATIVE_EXTENSION_NAME]]({
      href: this.form.href
    });
    this.close();
    this[PROPS$3.EDITOR].focus();
  };

  LinkWindow.prototype.close = function () {
    this.$destroy();
    this.$el.parentNode.removeChild(this.$el);
  };

  var _a, _b, _c, _d, _e;

  _a = PROPS$3.VALUE, _b = PROPS$3.NATIVE_EXTENSION_NAME, _c = PROPS$3.CONTEXT, _d = PROPS$3.EDITOR, _e = PROPS$3.HREF;

  __decorate([Prop({
    type: Boolean,
    default: false
  }), __metadata("design:type", Boolean)], LinkWindow.prototype, _a, void 0);

  __decorate([Prop({
    type: String,
    required: true
  }), __metadata("design:type", String)], LinkWindow.prototype, _b, void 0);

  __decorate([Prop({
    type: Object,
    required: true
  }), __metadata("design:type", Object)], LinkWindow.prototype, _c, void 0);

  __decorate([Prop({
    type: Object,
    required: true
  }), __metadata("design:type", Object)], LinkWindow.prototype, _d, void 0);

  __decorate([Prop({
    type: String
  }), __metadata("design:type", Object)], LinkWindow.prototype, _e, void 0);

  LinkWindow = __decorate([Component({
    components: {
      VDialog: VDialog,
      VCard: VCard,
      VCardTitle: VCardTitle,
      VCardText: VCardText,
      VCardActions: VCardActions,
      VBtn: VBtn,
      VSpacer: VSpacer,
      VIcon: VIcon,
      VTextField: VTextField
    }
  })], LinkWindow);
  return LinkWindow;
}(mixins(I18nMixin));

/* script */
const __vue_script__$5 = LinkWindow;

/* template */
var __vue_render__$5 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":_vm.value,"max-width":"500px"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("\n        "+_vm._s(_vm.$i18n.getMsg('extensions.Link.window.title'))+"\n      ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.close}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"label":_vm.$i18n.getMsg('extensions.Link.window.form.hrefLabel')},model:{value:(_vm.form.href),callback:function ($$v) {_vm.$set(_vm.form, "href", $$v);},expression:"form.href"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"text":""},on:{"click":_vm.close}},[_vm._v("\n        "+_vm._s(_vm.$i18n.getMsg('extensions.Link.window.buttons.close'))+"\n      ")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.isDisabled,"color":_vm.isRemove ? 'error' : 'primary',"text":""},on:{"click":_vm.apply}},[_vm._v("\n        "+_vm._s(_vm.$i18n.getMsg('extensions.Link.window.buttons.' + (_vm.isRemove ? 'remove' : 'apply')))+"\n      ")])],1)],1)],1)};
var __vue_staticRenderFns__$5 = [];

  /* style */
  const __vue_inject_styles__$5 = undefined;
  /* scoped */
  const __vue_scope_id__$5 = undefined;
  /* module identifier */
  const __vue_module_identifier__$5 = undefined;
  /* functional template */
  const __vue_is_functional_template__$5 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var LinkWindow$1 = normalizeComponent_1(
    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
    __vue_inject_styles__$5,
    __vue_script__$5,
    __vue_scope_id__$5,
    __vue_is_functional_template__$5,
    __vue_module_identifier__$5,
    undefined,
    undefined
  );

var Link =
/** @class */
function (_super) {
  __extends(Link, _super);

  function Link(options) {
    return _super.call(this, options, Link$1) || this;
  }

  Object.defineProperty(Link.prototype, "availableActions", {
    get: function get() {
      var _a;

      var nativeExtensionName = 'link';
      return [{
        render: new ExtensionActionRenderBtn$1({
          tooltip: function tooltip(context, options) {
            return new I18nText(options.isActive(context) ? 'extensions.Link.buttons.isActive.tooltip' : 'extensions.Link.buttons.notActive.tooltip');
          },
          icons: (_a = {}, _a["md"
          /* md */
          ] = new VuetifyIcon('link'), _a["fa"
          /* fa */
          ] = new VuetifyIcon('fas fa-link'), _a["mdi"
          /* mdi */
          ] = new VuetifyIcon('mdi-link'), _a["mdiSvg"
          /* mdiSvg */
          ] = new VuetifyIcon('M3.9,12C3.9,10.29 5.29,8.9 7,8.9H11V7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H11V15.1H7C5.29,15.1 3.9,13.71 3.9,12M8,13H16V11H8V13M17,7H13V8.9H17C18.71,8.9 20.1,10.29 20.1,12C20.1,13.71 18.71,15.1 17,15.1H13V17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7Z'), _a),
          nativeExtensionName: nativeExtensionName,
          onClick: function onClick(_a) {
            var context = _a.context,
                editor = _a.editor;
            var href = context.getMarkAttrs(nativeExtensionName).href;
            var LinkWindowComponent = Vue.extend(LinkWindow$1);
            var instance = new LinkWindowComponent({
              vuetify: Vue.prototype.tiptapVuetifyPlugin.vuetify,
              propsData: {
                value: true,
                nativeExtensionName: nativeExtensionName,
                context: context,
                editor: editor,
                href: href
              }
            });
            instance.$mount();
            document.querySelector('body').appendChild(instance.$el);
          }
        })
      }];
    },
    enumerable: true,
    configurable: true
  });
  return Link;
}(AbstractExtension);
//   save: {
//     [VuetifyIconsGroups.md]: new VuetifyIcon('check'),
//     [VuetifyIconsGroups.fa]: new VuetifyIcon('fas fa-check'),
//     [VuetifyIconsGroups.mdi]: new VuetifyIcon('mdi-check')
//   },
//   cancel: {
//     [VuetifyIconsGroups.md]: new VuetifyIcon('link_off'),
//     [VuetifyIconsGroups.fa]: new VuetifyIcon('fas fa-unlink'),
//     [VuetifyIconsGroups.mdi]: new VuetifyIcon('mdi-link-off')
//   },
//   linkUpdate: {
//     [VuetifyIconsGroups.md]: new VuetifyIcon('link'),
//     [VuetifyIconsGroups.fa]: new VuetifyIcon('fas fas fa-link'),
//     [VuetifyIconsGroups.mdi]: new VuetifyIcon('mdi-link')
//   },
//   linkAdd: {
//     [VuetifyIconsGroups.md]: new VuetifyIcon('link'),
//     [VuetifyIconsGroups.fa]: new VuetifyIcon('fas fa-link'),
//     [VuetifyIconsGroups.mdi]: new VuetifyIcon('mdi-link-plus')
//   }
// }

var $filter = arrayIteration.filter;


// `Array.prototype.filter` method
// https://tc39.github.io/ecma262/#sec-array.prototype.filter
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !arrayMethodHasSpeciesSupport('filter') }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  hide(ArrayPrototype, UNSCOPABLES, objectCreate(null));
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var $includes = arrayIncludes.includes;


// `Array.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
_export({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var notARegexp = function (it) {
  if (isRegexp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};

var MATCH$1 = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (e) {
    try {
      regexp[MATCH$1] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (f) { /* empty */ }
  } return false;
};

// `String.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-string.prototype.includes
_export({ target: 'String', proto: true, forced: !correctIsRegexpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegexp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});

var EVENTS$1 = {
  SELECT_FILES: 'select-files'
};
var HOLDER_CLASS = 'tiptap-vuetify-image-upload-area-holder';

var ImageUploadArea =
/** @class */
function (_super) {
  __extends(ImageUploadArea, _super);

  function ImageUploadArea() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ImageUploadArea.prototype.mounted = function () {
    var _this = this;

    var holder = this.$el.querySelector('.' + HOLDER_CLASS);
    var input = this.$el.querySelector('#tiptap-vuetify-image-upload-area__input-file');
    input.addEventListener('change', function (e) {
      if (e.target instanceof HTMLInputElement) {
        _this.$emit(EVENTS$1.SELECT_FILES, e.target.files);

        holder.classList.remove(HOLDER_CLASS + '--dragover');
        e.target.value = '';
      }
    });
    holder.addEventListener('dragover', function () {
      holder.classList.add(HOLDER_CLASS + '--dragover');
      return false;
    });

    var dragleaveOrEndHandler = function dragleaveOrEndHandler() {
      holder.classList.remove(HOLDER_CLASS + '--dragover');
      return false;
    };

    holder.addEventListener('dragleave', dragleaveOrEndHandler);
    holder.addEventListener('dragend', dragleaveOrEndHandler);
    holder.addEventListener('drop', function (e) {
      e.preventDefault();

      _this.$emit(EVENTS$1.SELECT_FILES, e.dataTransfer.files);
    });
  };

  ImageUploadArea = __decorate([Component], ImageUploadArea);
  return ImageUploadArea;
}(mixins(I18nMixin));

/* script */
const __vue_script__$6 = ImageUploadArea;
/* template */
var __vue_render__$6 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tiptap-vuetify-image-upload-area"},[_c('input',{attrs:{"id":"tiptap-vuetify-image-upload-area__input-file","type":"file","accept":"image/*","multiple":""}}),_vm._v(" "),_c('label',{staticClass:"tiptap-vuetify-image-upload-area-holder",attrs:{"for":"tiptap-vuetify-image-upload-area__input-file"}},[_c('div',[_c('svg',{staticClass:"tiptap-vuetify-image-upload-area-holder__icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"50","height":"43","viewBox":"0 0 50 43"}},[_c('path',{attrs:{"d":"M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z"}})]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Choose a file(s) or drag it here.")])])])])};
var __vue_staticRenderFns__$6 = [];

  /* style */
  const __vue_inject_styles__$6 = undefined;
  /* scoped */
  const __vue_scope_id__$6 = undefined;
  /* module identifier */
  const __vue_module_identifier__$6 = undefined;
  /* functional template */
  const __vue_is_functional_template__$6 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var ImageUploadArea$1 = normalizeComponent_1(
    { render: __vue_render__$6, staticRenderFns: __vue_staticRenderFns__$6 },
    __vue_inject_styles__$6,
    __vue_script__$6,
    __vue_scope_id__$6,
    __vue_is_functional_template__$6,
    __vue_module_identifier__$6,
    undefined,
    undefined
  );

function createJavaScriptTransition(name, functions, mode = 'in-out') {
  return {
    name,
    functional: true,
    props: {
      mode: {
        type: String,
        default: mode
      }
    },

    render(h, context) {
      const data = {
        props: { ...context.props,
          name
        },
        on: functions
      };
      return h('transition', data, context.children);
    }

  };
}
let passiveSupported = false;

try {
  if (typeof window !== 'undefined') {
    const testListenerOpts = Object.defineProperty({}, 'passive', {
      get: () => {
        passiveSupported = true;
      }
    });
    window.addEventListener('testListener', testListenerOpts, testListenerOpts);
    window.removeEventListener('testListener', testListenerOpts, testListenerOpts);
  }
} catch (e) {
  console.warn(e);
}

const keyCodes = Object.freeze({
  enter: 13,
  tab: 9,
  delete: 46,
  esc: 27,
  space: 32,
  up: 38,
  down: 40,
  left: 37,
  right: 39,
  end: 35,
  home: 36,
  del: 46,
  backspace: 8,
  insert: 45,
  pageup: 33,
  pagedown: 34
}); // This remaps internal names like '$cancel' or '$vuetify.icons.cancel'
/**
 * Makes the first character of a string uppercase
 */

function upperFirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function ExpandTransitionGenerator (expandedParentClass = '', x = false) {
  const sizeProperty = x ? 'width' : 'height';
  const offsetProperty = `offset${upperFirst(sizeProperty)}`;
  return {
    beforeEnter(el) {
      el._parent = el.parentNode;
      el._initialStyle = {
        transition: el.style.transition,
        visibility: el.style.visibility,
        overflow: el.style.overflow,
        [sizeProperty]: el.style[sizeProperty]
      };
    },

    enter(el) {
      const initialStyle = el._initialStyle;
      const offset = `${el[offsetProperty]}px`;
      el.style.setProperty('transition', 'none', 'important');
      el.style.visibility = 'hidden';
      el.style.visibility = initialStyle.visibility;
      el.style.overflow = 'hidden';
      el.style[sizeProperty] = '0';
      void el.offsetHeight; // force reflow

      el.style.transition = initialStyle.transition;

      if (expandedParentClass && el._parent) {
        el._parent.classList.add(expandedParentClass);
      }

      requestAnimationFrame(() => {
        el.style[sizeProperty] = offset;
      });
    },

    afterEnter: resetStyles,
    enterCancelled: resetStyles,

    leave(el) {
      el._initialStyle = {
        transition: '',
        visibility: '',
        overflow: el.style.overflow,
        [sizeProperty]: el.style[sizeProperty]
      };
      el.style.overflow = 'hidden';
      el.style[sizeProperty] = `${el[offsetProperty]}px`;
      void el.offsetHeight; // force reflow

      requestAnimationFrame(() => el.style[sizeProperty] = '0');
    },

    afterLeave,
    leaveCancelled: afterLeave
  };

  function afterLeave(el) {
    if (expandedParentClass && el._parent) {
      el._parent.classList.remove(expandedParentClass);
    }

    resetStyles(el);
  }

  function resetStyles(el) {
    const size = el._initialStyle[sizeProperty];
    el.style.overflow = el._initialStyle.overflow;
    if (size != null) el.style[sizeProperty] = size;
    delete el._initialStyle;
  }
}

const VExpandTransition = createJavaScriptTransition('expand-transition', ExpandTransitionGenerator());
const VExpandXTransition = createJavaScriptTransition('expand-x-transition', ExpandTransitionGenerator('', true));

var PROPS$4 = {
  VALUE: 'value',
  CONTEXT: 'context',
  EDITOR: 'editor',
  NATIVE_EXTENSION_NAME: 'nativeExtensionName'
};

var ImageWindow =
/** @class */
function (_super) {
  __extends(ImageWindow, _super);

  function ImageWindow() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.form = {
      src: null // 'https://www.nationalgeographic.com/content/dam/news/2018/05/17/you-can-train-your-cat/02-cat-training-NationalGeographic_1484324.jpg'

    };
    _this.inputPreviewSources = [];
    return _this;
  }

  Object.defineProperty(ImageWindow.prototype, "previewSources", {
    get: function get() {
      return __spread([this.form.src], this.inputPreviewSources).filter(Boolean);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ImageWindow.prototype, "isDisabled", {
    get: function get() {
      return !this.previewSources.length;
    },
    enumerable: true,
    configurable: true
  });

  ImageWindow.prototype.removeSource = function (source) {
    if (this.inputPreviewSources.includes(source)) {
      this.inputPreviewSources = this.inputPreviewSources.filter(function (i) {
        return i !== source;
      });
    } else if (this.form.src === source) {
      this.form.src = null;
    }
  };

  ImageWindow.prototype.onFilesSelect = function (files) {
    var _this = this;

    __spread(files).forEach(function (file) {
      var reader = new FileReader();
      reader.addEventListener('load', function (readerEvent) {
        // TODO URL.createObjectURL(file) and upload
        _this.inputPreviewSources.push(readerEvent.target.result.toString());
      });
      reader.readAsDataURL(file);
    });
  };

  ImageWindow.prototype.apply = function () {
    var _this = this;

    this.previewSources.forEach(function (src) {
      _this[PROPS$4.CONTEXT].commands[_this[PROPS$4.NATIVE_EXTENSION_NAME]]({
        // TODO alt, title
        src: src,
        alt: 'Image'
      });
    });
    this.close();
    this[PROPS$4.EDITOR].focus();
  };

  ImageWindow.prototype.close = function () {
    this.$destroy();
    this.$el.parentNode.removeChild(this.$el);
  };

  var _a, _b, _c, _d;

  _a = PROPS$4.VALUE, _b = PROPS$4.NATIVE_EXTENSION_NAME, _c = PROPS$4.CONTEXT, _d = PROPS$4.EDITOR;

  __decorate([Prop({
    type: Boolean,
    default: false
  }), __metadata("design:type", Boolean)], ImageWindow.prototype, _a, void 0);

  __decorate([Prop({
    type: String,
    required: true
  }), __metadata("design:type", String)], ImageWindow.prototype, _b, void 0);

  __decorate([Prop({
    type: Object,
    required: true
  }), __metadata("design:type", Object)], ImageWindow.prototype, _c, void 0);

  __decorate([Prop({
    type: Object,
    required: true
  }), __metadata("design:type", Object)], ImageWindow.prototype, _d, void 0);

  ImageWindow = __decorate([Component({
    components: {
      VRow: VRow,
      VCol: VCol,
      VExpandTransition: VExpandTransition,
      ImageUploadArea: ImageUploadArea$1,
      VImg: VImg,
      VDialog: VDialog,
      VCard: VCard,
      VCardTitle: VCardTitle,
      VCardText: VCardText,
      VCardActions: VCardActions,
      VBtn: VBtn,
      VSpacer: VSpacer,
      VIcon: VIcon,
      VTextField: VTextField
    }
  })], ImageWindow);
  return ImageWindow;
}(mixins(I18nMixin));

/* script */
const __vue_script__$7 = ImageWindow;

/* template */
var __vue_render__$7 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":_vm.value,"max-width":"500px"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("\n        "+_vm._s(_vm.$i18n.getMsg('extensions.Image.window.title'))+"\n      ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.close}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-expand-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.previewSources.length),expression:"previewSources.length"}]},[_c('v-row',{attrs:{"no-gutters":"","justify":"center","align":"center"}},_vm._l((_vm.previewSources),function(source,i){return _c('v-col',{key:'preview' + i,attrs:{"cols":"4"}},[_c('v-img',{staticClass:"text-right",attrs:{"src":source}},[_c('v-btn',{attrs:{"icon":"","small":"","dark":""},on:{"click":function($event){return _vm.removeSource(source)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("\n                    close\n                  ")])],1)],1)],1)}),1)],1)]),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm.$i18n.getMsg('extensions.Image.window.form.sourceLink')},model:{value:(_vm.form.src),callback:function ($$v) {_vm.$set(_vm.form, "src", $$v);},expression:"form.src"}}),_vm._v(" "),_c('v-expand-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.form.src),expression:"!form.src"}]},[_c('div',{staticClass:"text-center grey--text mt-2 mb-4"},[_vm._v("\n            "+_vm._s(_vm.$i18n.getMsg('extensions.Image.window.or'))+"\n          ")]),_vm._v(" "),_c('ImageUploadArea',{on:{"select-files":_vm.onFilesSelect}})],1)])],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"text":""},on:{"click":_vm.close}},[_vm._v("\n        "+_vm._s(_vm.$i18n.getMsg('extensions.Image.window.buttons.close'))+"\n      ")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.isDisabled,"text":""},on:{"click":_vm.apply}},[_vm._v("\n        "+_vm._s(_vm.$i18n.getMsg('extensions.Image.window.buttons.apply'))+"\n      ")])],1)],1)],1)};
var __vue_staticRenderFns__$7 = [];

  /* style */
  const __vue_inject_styles__$7 = undefined;
  /* scoped */
  const __vue_scope_id__$7 = undefined;
  /* module identifier */
  const __vue_module_identifier__$7 = undefined;
  /* functional template */
  const __vue_is_functional_template__$7 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var ImageWindow$1 = normalizeComponent_1(
    { render: __vue_render__$7, staticRenderFns: __vue_staticRenderFns__$7 },
    __vue_inject_styles__$7,
    __vue_script__$7,
    __vue_scope_id__$7,
    __vue_is_functional_template__$7,
    __vue_module_identifier__$7,
    undefined,
    undefined
  );

var Image =
/** @class */
function (_super) {
  __extends(Image, _super);

  function Image(options) {
    return _super.call(this, options, Image$1) || this;
  }

  Object.defineProperty(Image.prototype, "availableActions", {
    get: function get() {
      var _a;

      var nativeExtensionName = 'image';
      return [{
        render: new ExtensionActionRenderBtn$1({
          tooltip: new I18nText('extensions.Image.buttons.tooltip'),
          icons: (_a = {}, _a["md"
          /* md */
          ] = new VuetifyIcon('image'), _a["fa"
          /* fa */
          ] = new VuetifyIcon('fas fa-image'), _a["mdi"
          /* mdi */
          ] = new VuetifyIcon('mdi-image'), _a["mdiSvg"
          /* mdiSvg */
          ] = new VuetifyIcon('M8.5,13.5L11,16.5L14.5,12L19,18H5M21,19V5C21,3.89 20.1,3 19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19Z'), _a),
          nativeExtensionName: nativeExtensionName,
          onClick: function onClick(_a) {
            var context = _a.context,
                editor = _a.editor;
            return __awaiter(this, void 0, void 0, function () {
              var LinkWindowComponent, instance;
              return __generator(this, function (_b) {
                LinkWindowComponent = Vue.extend(ImageWindow$1);
                instance = new LinkWindowComponent({
                  vuetify: Vue.prototype.tiptapVuetifyPlugin.vuetify,
                  propsData: {
                    value: true,
                    nativeExtensionName: nativeExtensionName,
                    context: context,
                    editor: editor
                  }
                });
                instance.$mount();
                document.querySelector('body').appendChild(instance.$el);
                return [2
                /*return*/
                ];
              });
            });
          }
        })
      }];
    },
    enumerable: true,
    configurable: true
  });
  return Image;
}(AbstractExtension);

// It is bad practice to mix default and named exports in the same module, though it is allowed by the specification.

var TiptapVuetifyPlugin = new (
/** @class */
function () {
  function Plugin() {
    this.installed = false;
  }

  Object.defineProperty(Plugin.prototype, "vuetifyLang", {
    get: function get() {
      return this.vuetify.framework.lang.current;
    },
    enumerable: true,
    configurable: true
  });

  Plugin.prototype.install = function (VueFuncConstructor, options) {
    if (!options || !options.vuetify) {
      ConsoleLogger$1.error('Please, specify in options the Vuetify Object ("vuetify" property)');
      return;
    }

    var vuetifyFramework = options.vuetify,
        _a = options.iconsGroup,
        iconsGroup = _a === void 0 ? theme.defaultIconsGroup : _a;
    VueFuncConstructor.prototype.tiptapVuetifyPlugin = TiptapVuetifyPlugin;
    VueFuncConstructor.prototype.$tiptapVuetify = {
      iconsGroup: iconsGroup
    };
    this.vuetify = vuetifyFramework;
    this.installed = true;
  };

  return Plugin;
}())();

(function autoInstall() {
  var globalScope = null;

  if (typeof window !== 'undefined') {
    globalScope = window;
  } else if (typeof global !== 'undefined') {
    // @ts-ignore
    globalScope = global;
  }

  if (globalScope && globalScope.Vue) {
    // Automatic installation if Vue has been added to the global scope.
    globalScope.Vue.use(TiptapVuetifyPlugin, __assign({
      vuetify: globalScope.vuetify
    }, globalScope.tiptapVuetifyPluginOptions));
    globalScope.Vue.component('tiptap-vuetify', TiptapVuetify$1);
  }
})();

export { Blockquote, Bold, BulletList, Code, CodeBlock, HardBreak, Heading, History, HorizontalRule, Image, Italic, Link, ListItem, OrderedList, Paragraph, Strike, TiptapVuetify$1 as TiptapVuetify, TiptapVuetifyPlugin, Underline };
